/* CHỢ HẺM — theme JS. 17 khối script của web HTML ghép lại; các chỗ vá ghi rõ ở từng khối. */


(function(){
  var D=JSON.parse(document.getElementById('demo-img').textContent);
  /* SVG rỗng giữ đúng khung ảnh khi sản phẩm chưa có hình */
  var EMPTY='data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%224%22 height=%223%22%3E%3C/svg%3E';
  function fix(root){
    root.querySelectorAll('img[data-img]').forEach(function(n){
      if(n.getAttribute('src')) return;
      var v=D[n.getAttribute('data-img')];
      if(v){ n.src=v; n.classList.remove('img-empty'); }
      else { n.src=EMPTY; n.classList.add('img-empty'); }   /* chưa có ảnh -> ô chờ */
    });
    root.querySelectorAll('[data-full-key]').forEach(function(n){ n.setAttribute('data-full', D[n.getAttribute('data-full-key')]||''); });
  }
  window.CHFixImg = fix;   /* giỏ hàng dựng dòng mới xong thì gọi để gán ảnh */
  document.addEventListener('DOMContentLoaded',function(){
    fix(document);
    var body=document.querySelector('[data-qv-body]');
    if(!body) return;
    new MutationObserver(function(){ fix(body); }).observe(body,{childList:true,subtree:true});
  });
})();



/* ---------- ĐỔI ĐƯỜNG DẪN GIẢ (#/p1, #/c/…) SANG ĐƯỜNG DẪN THẬT ----------
   Vài khối JS của web HTML còn ghi sẵn #/… ; bảng này do Liquid sinh (chohem-CH). */
(function(){
  var CH = {}; try { CH = JSON.parse(document.getElementById('chohem-CH').textContent); } catch(e){}
  window.CH_ROUTES = CH;
  var P = CH.pages || {};
  window.CHHref = function(h){
    if (!h || h.charAt(0) !== '#') return h;
    if (h === '#/home') return CH.root || '/';
    if (h === '#/cart') return CH.cart || '/cart';
    if (h.indexOf('#/p') === 0) { var k = h.slice(2).split('#')[0]; return (P[k] || '#') + (h.indexOf('#', 2) > -1 ? '#' + h.split('#').pop() : ''); }
    if (h.indexOf('#/c/all') === 0) return (CH.collections || '/collections') + '/all';
    if (h.indexOf('#/c/') === 0) return (CH.collections || '/collections') + '/' + h.slice(4);
    if (h.indexOf('#/f/') === 0) { var f = h.slice(4); return (CH.flags && CH.flags[f]) || ((CH.collections || '/collections') + '/all'); }
    return h;
  };
  /* mọi link còn sót dạng #/… trong trang: đổi một lượt lúc tải */
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('a[href^="#/"]').forEach(function(a){ a.setAttribute('href', window.CHHref(a.getAttribute('href'))); });
  });
})();


/* ======================================================================
   CHỢ HẺM — GIỎ HÀNG THẬT (Shopify Cart AJAX API)
   Đây là bản chuyển của "script mô phỏng giỏ" trong web HTML: giữ nguyên
   mọi hàm dựng giao diện (drawerRow, cartRow, render, expandQty...) và chỉ
   thay nguồn dữ liệu: `lines` lấy từ /cart.js, mọi thay đổi đi qua
   /cart/add.js và /cart/change.js rồi nạp lại.
   ====================================================================== */
(function(){
  var CH = {};
  try { CH = JSON.parse(document.getElementById('chohem-CH').textContent); } catch(e){ CH = {}; }
  var ROOT = (CH.root || '/');
  var THRESH = CH.thresh || 19900;
  var DONO_ID = String(CH.donoId || '');
  var lines = [];            /* [{k,n,v,p,q,id,key}] — k = handle */
  var donation = 0;          /* số $ ủng hộ = số lượng dòng sản phẩm ủng hộ */
  var donoKey = '';

  function money(c){ return c ? fmt(c) : 'Liên hệ'; }
  function total(c){ return fmt(c); }
  /* Định dạng tiền theo cửa hàng (mặc định $12.34) */
  function fmt(c){
    var s = (Math.round(c)/100).toFixed(2);
    var f = CH.money || '${{amount}}';
    if (f.indexOf('amount_no_decimals') > -1) s = String(Math.round(c/100));
    else if (f.indexOf('amount_with_comma_separator') > -1) s = s.replace('.', ',');
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s).replace(/<[^>]+>/g,'');
  }
  function sub(){ return lines.reduce(function(s,l){ return s + l.p*l.q; }, 0); }
  function cnt(){ return lines.reduce(function(s,l){ return s + l.q; }, 0); }
  function esc(t){ return String(t).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;'); }

  /* ---- đọc giỏ Shopify -> lines ---- */
  function fromCart(cart){
    var out = [], d = 0, dk = '';
    (cart.items || []).forEach(function(it){
      if (DONO_ID && String(it.variant_id) === DONO_ID) { d = it.quantity; dk = it.key; return; }
      var v = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      out.push({ k: it.handle, n: it.product_title, v: v, p: it.price, q: it.quantity,
                 id: it.variant_id, key: it.key, url: it.url, img: it.image });
    });
    lines = out; donation = d; donoKey = dk;
    /* ảnh dòng giỏ: nạp vào bank để CHFixImg gán */
    try {
      var bank = document.getElementById('demo-img');
      if (bank) {
        var B = JSON.parse(bank.textContent); var changed = false;
        out.forEach(function(l){ if (l.img && !B[l.k]) { B[l.k] = l.img; changed = true; } });
        if (changed) bank.textContent = JSON.stringify(B);
      }
    } catch(e){}
  }

  /* ---- API: gom mọi cú bấm thành MỘT yêu cầu /cart/update.js ----
     Trước: mỗi cú bấm = 1 POST + 1 GET /cart.js, xếp hàng tuần tự → bấm nhanh 5 lần
     là 10 lượt đi-về, số nhảy lùi rồi mới tới; bấm lần 2 lên món mới (chưa có key) bị nuốt.
     Nay: cập nhật giao diện ngay, ghi "số lượng mong muốn" theo variant, 150ms sau gửi
     1 yêu cầu update.js (tuyệt đối, nhiều món một lúc), trả về cả giỏ nên khỏi GET lại.
     Đang gửi mà bấm tiếp thì gom vào đợt sau; chỉ áp trạng thái server khi không còn gì chờ. */
  var pending = {}, inflight = false, timer = null, waiters = [];
  function hdr(){ return { 'Content-Type':'application/json', 'Accept':'application/json' }; }
  function reload(){
    return fetch(ROOT + 'cart.js', { headers:{'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(c){ if (!hasPending()) { fromCart(c); render(); } return c; });
  }
  function hasPending(){ for (var k in pending) return true; return false; }
  function want(vid, qty){
    if (!vid) return Promise.resolve();
    pending[String(vid)] = Math.max(0, Math.floor(qty));
    var pr = new Promise(function(res){ waiters.push(res); });
    clearTimeout(timer); timer = setTimeout(flush, 150);
    return pr;
  }
  function flush(){
    if (inflight || !hasPending()) return;
    var upd = pending, ws = waiters; pending = {}; waiters = []; inflight = true;
    fetch(ROOT + 'cart/update.js', { method:'POST', headers: hdr(), body: JSON.stringify({ updates: upd }) })
      .then(function(r){ return r.json(); })
      .then(function(c){
        if (c && c.items) { if (!hasPending()) { fromCart(c); render(); } }
        else return reload();                      /* 422 (hết hàng…) → lấy lại giỏ thật cho khớp */
      })
      .catch(function(){ return reload().catch(function(){}); })
      .then(function(){
        inflight = false;
        ws.forEach(function(f){ try { f(); } catch(e){} });
        if (hasPending()) flush();
      });
  }
  function localQty(vid){
    var l = lines.filter(function(x){ return String(x.id) === String(vid); })[0];
    return l ? l.q : 0;
  }
  /* đặt số lượng tuyệt đối cho một dòng (giao diện đã cập nhật ở chỗ gọi) */
  function setLineQty(l, qty){
    if (!l || !l.id) return Promise.resolve();
    return want(l.id, qty);
  }
  /* cộng thêm qty cho variant (nơi gọi CHƯA cập nhật giao diện: mua ngay, trang sản phẩm) */
  function addLine(variantId, qty){
    qty = Math.max(1, Math.floor(qty || 1));
    var vid = String(variantId);
    var base = (vid in pending) ? pending[vid] : localQty(vid);
    var l = lines.filter(function(x){ return String(x.id) === vid; })[0];
    if (l) { l.q = base + qty; render(); }
    return want(vid, base + qty);
  }
  function setDonoQty(qty){
    qty = Math.max(0, Math.floor(qty));
    if (!DONO_ID) return Promise.resolve();
    return want(DONO_ID, qty);
  }
  function findLine(k){ return lines.filter(function(x){ return x.k === k; })[0]; }

  /* ---- dựng dòng (chép nguyên từ web HTML) ---- */
  function drawerRow(l){
    var k = esc(l.k), n = esc(l.n), u = esc(l.url || '#');
    return '<li class="cdw__item" data-line="'+k+'"><span class="cdw__thumb" data-quick-view="'+k+'">'+
      '<img data-img="'+k+'" alt=""></span><div class="cdw__info">'+
      '<p class="cdw__name"><a href="'+u+'" data-quick-view="'+k+'">'+n+'</a></p>'+
      '<p class="cdw__variant">'+esc(l.v)+'</p>'+
      '<div class="cdw__row"><p class="cdw__unit" data-line-unit>'+money(l.p)+'</p>'+
        '<div class="qty qty--cdw">'+
        '<button type="button" data-demo-qty="down" aria-label="Giảm">&minus;</button>'+
        '<input type="number" value="'+l.q+'" min="0" data-demo-qty-input aria-label="Số lượng '+n+'">'+
        '<button type="button" data-demo-qty="up" aria-label="Tăng">+</button></div>'+
        '<p class="cdw__price" data-line-total>'+money(l.p*l.q)+'</p></div>'+
      '<button class="cdw__remove" type="button" data-demo-remove>Xóa</button></div></li>';
  }
  function cartRow(l){
    var k = esc(l.k), n = esc(l.n), u = esc(l.url || '#');
    return '<div class="ctable__row" data-line="'+k+'">'+
      '<div class="ctable__prod"><span class="ctable__thumb" data-quick-view="'+k+'">'+
        '<img data-img="'+k+'" alt=""></span>'+
        '<div><p class="ctable__name"><a href="'+u+'" data-quick-view="'+k+'">'+n+'</a></p>'+
        '<p class="ctable__variant">'+esc(l.v)+'</p></div></div>'+
      '<div class="ctable__price">'+money(l.p)+'</div>'+
      '<div class="ctable__qty"><div class="qty qty--sm">'+
        '<button type="button" data-demo-qty="down" aria-label="Giảm">&minus;</button>'+
        '<input type="number" value="'+l.q+'" min="0" data-demo-qty-input aria-label="Số lượng '+n+'">'+
        '<button type="button" data-demo-qty="up" aria-label="Tăng">+</button></div></div>'+
      '<div class="ctable__line"><span class="ctable__total" data-line-total>'+money(l.p*l.q)+'</span>'+
      '<button class="ctable__remove" type="button" data-demo-remove>Xóa</button></div></div>';
  }
  function syncRows(){
    var added = false;
    document.querySelectorAll('.cdw__items').forEach(function(ul){
      lines.forEach(function(l){
        if(ul.querySelector('[data-line="'+l.k+'"]')) return;
        ul.insertAdjacentHTML('beforeend', drawerRow(l)); added = true;
      });
      /* dòng đã bị xoá khỏi giỏ thật thì gỡ hẳn */
      [].forEach.call(ul.querySelectorAll('[data-line]'), function(row){
        if (!findLine(row.getAttribute('data-line'))) row.remove();
      });
    });
    document.querySelectorAll('.ctable').forEach(function(tb){
      lines.forEach(function(l){
        if(tb.querySelector('[data-line="'+l.k+'"]')) return;
        tb.insertAdjacentHTML('beforeend', cartRow(l)); added = true;
      });
      [].forEach.call(tb.querySelectorAll('[data-line]'), function(row){
        if (!findLine(row.getAttribute('data-line'))) row.remove();
      });
    });
    if(added && window.CHFixImg) window.CHFixImg(document);
  }
  function inCart(k){ var l = findLine(k); return !!(l && l.q > 0); }
  function syncRecs(){
    document.querySelectorAll('.cdw__rec .rel__grid,.cartpage__rec .rel__grid,.rel .rel__grid').forEach(function(grid){
      var left = 0;
      grid.querySelectorAll('.rel__card').forEach(function(card){
        var a = card.querySelector('[data-quick-view]');
        var hide = !!(a && inCart(a.getAttribute('data-quick-view')));
        card.hidden = hide;
        if (!hide) left++;
      });
      var sec = grid.closest('.cdw__rec,.cartpage__rec,.rel');
      if (sec) sec.hidden = left === 0;
      if (left) grid.scrollLeft = 0;
    });
  }
  window.CHPreviewCart = true;      /* để bộ xử lý ủng hộ trong theme-script nhường chỗ (như web HTML) */
  window.CHInCart = inCart;
  window.CHSyncRecs = syncRecs;
  new MutationObserver(function(recs){
    for (var i = 0; i < recs.length; i++) {
      var ns = recs[i].addedNodes;
      for (var j = 0; j < ns.length; j++) {
        var n = ns[j];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches('.rel')) || (n.querySelector && n.querySelector('.rel__grid'))) { syncRecs(); return; }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  function render(){
    syncRows();
    syncRecs();
    var s = sub(), d = donation*100;
    document.querySelectorAll('[data-sub]').forEach(function(n){ n.textContent = total(s); });
    document.querySelectorAll('[data-total]').forEach(function(n){ n.textContent = total(s+d); });
    document.querySelectorAll('[data-dono-val]').forEach(function(n){ n.textContent = total(d); });
    document.querySelectorAll('[data-dono-row],[data-total-row]').forEach(function(n){ n.hidden = d === 0; });
    document.querySelectorAll('[data-dw-count]').forEach(function(n){ n.textContent = cnt(); });
    document.querySelectorAll('.action__count').forEach(function(n){ n.textContent = cnt(); n.hidden = cnt() === 0; });
    var empty = document.querySelector('[data-dw-empty]'); if (empty) empty.hidden = cnt() > 0;
    var rong = cnt() === 0;
    document.querySelectorAll('.cdw .fship,.cdw__foot .csum,.cdw__checkout,.cdw .dono:not([data-dono-off])')
      .forEach(function(n){ n.hidden = rong; });
    document.querySelectorAll('[data-cp-count]').forEach(function(n){ n.textContent = cnt(); });
    document.querySelectorAll('[data-cp-empty]').forEach(function(n){ n.hidden = cnt() > 0; });
    document.querySelectorAll('.ctable__head').forEach(function(n){ n.hidden = cnt() === 0; });
    /* trang giỏ: giỏ rỗng thì ẩn tóm tắt/ủng hộ/thanh toán, giữ hàng gợi ý */
    document.querySelectorAll('.csummary .fship,.csummary .csum,.csummary .cdw__checkout,.csummary .dono:not([data-dono-off])')
      .forEach(function(n){ n.hidden = rong; });
    document.querySelectorAll('.addbtn[data-demo-item]').forEach(function(btn){
      var host = btn.closest(QTY_HOST) || btn.parentElement;
      if (!host || host.querySelector('[data-cardqty]')) return;
      try {
        var it = JSON.parse(btn.getAttribute('data-demo-item'));
        var ln = findLine(it.k);
        if (ln && ln.q > 0) expandQty(btn, it.k, it.n, ln.q);
      } catch (err) {}
    });
    document.querySelectorAll('[data-cardqty]').forEach(function(box){
      var key = box.getAttribute('data-cardqty');
      var ln = findLine(key);
      var q = ln ? ln.q : 0;
      if (q <= 0) { collapseQty(box); return; }
      var n = box.querySelector('[data-cardqty-num]');
      if (n && document.activeElement !== n) n.value = q;
    });
    lines.forEach(function(l){
      document.querySelectorAll('[data-line="'+l.k+'"]').forEach(function(row){
        row.hidden = l.q === 0;
        var t = row.querySelector('[data-line-total]'); if (t) t.textContent = money(l.p*l.q);
        var un = row.querySelector('[data-line-unit]'); if (un) un.textContent = money(l.p);
        var u = row.querySelector('.ctable__price'); if (u) u.textContent = money(l.p);
        var i = row.querySelector('[data-demo-qty-input]');
        if (i && document.activeElement !== i) i.value = l.q;
      });
    });
    document.querySelectorAll('[data-donation]').forEach(function(mod){
      mod.setAttribute('data-amount', donation);
      var preset = false;
      mod.querySelectorAll('[data-dono-amt]').forEach(function(b){
        var on = donation > 0 && parseInt(b.getAttribute('data-dono-amt'),10) === donation;
        if (on) preset = true;
        b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on?'true':'false');
      });
      var oth = mod.querySelector('[data-dono-other]'); if (oth) oth.classList.toggle('is-active', donation > 0 && !preset);
    });
    document.querySelectorAll('[data-fship]').forEach(function(f){
      var th = parseInt(f.getAttribute('data-thresh') || THRESH, 10) || THRESH;
      var remain = th - s, pct = Math.min(100, Math.round(s*100/th));
      f.classList.toggle('is-done', remain <= 0);
      var ti = f.querySelector('[data-fship-title]');
      if (ti) ti.textContent = remain > 0 ? 'Gần tới rồi!' : 'Miễn phí vận chuyển!';
      var tx = f.querySelector('[data-fship-text]');
      if (tx) { if (remain > 0) tx.innerHTML = 'Mua thêm <b>' + money(remain) + '</b> nữa để được giao hàng miễn phí.';
                else tx.textContent = 'Đơn của bạn đã được giao hàng miễn phí.'; }
      var bar = f.querySelector('[data-fship-bar]'); if (bar) bar.style.width = pct + '%';
    });
  }
  var QTY_HOST = '.pcard__mediabox,.rel__mediabox,.pcard__foot,.rcard__product,.rpitem__product';
  function expandQty(btn, key, name, qty){
    var foot = btn.closest(QTY_HOST) || btn.parentElement;
    if (!foot || foot.querySelector('[data-cardqty]')) return;
    var box = document.createElement('div');
    box.className = 'qtybox';
    box.setAttribute('data-cardqty', key);
    box.innerHTML =
      '<button type="button" data-cardqty-step="-1" aria-label="Bớt một ' + esc(name) + '">−</button>' +
      '<input type="text" inputmode="numeric" data-cardqty-num value="' + (qty || 1) +
        '" aria-label="Số lượng ' + esc(name) + '">' +
      '<button type="button" data-cardqty-step="1" aria-label="Thêm một ' + esc(name) + '">+</button>';
    foot.appendChild(box);
    foot.classList.add('is-qty');
  }
  function collapseQty(box){
    var foot = box.closest(QTY_HOST) || box.parentElement;
    box.remove();
    if (!foot) return;
    foot.classList.remove('is-qty');
    var btn = foot.querySelector('.addbtn');
    if (btn) {
      btn.classList.remove('is-added');
      var icon = btn.querySelector('[data-add-icon]') || btn.firstElementChild || btn;
      icon.textContent = '+';
    }
  }

  /* ---- ủng hộ ---- */
  function setDono(v){
    v = (v>0 && isFinite(v)) ? Math.floor(v) : 0;
    donation = v; render();                 /* hiện ngay, rồi đồng bộ với Shopify */
    setDonoQty(v);
  }
  function apply(mod){
    var input = mod.querySelector('[data-dono-input]'), hint = mod.querySelector('[data-dono-hint]');
    var raw = (input.value||'').trim(); hint.hidden = true;
    if (raw === '') { setDono(0); return; }
    var n = Number(raw);
    if (!isFinite(n) || isNaN(n) || n <= 0) { hint.textContent='Nhập số tiền lớn hơn 0.'; hint.hidden=false; return; }
    if (Math.floor(n) !== n) { hint.textContent='Chỉ nhận số tiền chẵn (1, 2, 3…).'; hint.hidden=false; return; }
    setDono(n);
  }

  /* ---- thay đổi số lượng: cập nhật tại chỗ rồi gửi API ---- */
  function changeQty(l, q){
    if (!l) return;
    l.q = Math.max(0, q); render();
    setLineQty(l, l.q);
  }
  function addByMeta(it){
    var ex = findLine(it.k);
    if (ex) { ex.q += 1; render(); setLineQty(ex, ex.q); return; }
    var nl = {k:it.k, n:it.n, v:it.v, p:it.p, q:1, id:it.id, key:''};
    lines.push(nl);
    render();
    setLineQty(nl, 1);
  }

  document.addEventListener('click', function(e){
    var mod = e.target.closest('[data-donation]');
    if (mod) {
      var a = e.target.closest('[data-dono-amt]');
      if (a) { var v = parseInt(a.getAttribute('data-dono-amt'),10); setDono(donation===v ? 0 : v); return; }
      if (e.target.closest('[data-dono-other]')) {
        var box = mod.querySelector('[data-dono-custom]'), btn = mod.querySelector('[data-dono-other]');
        var willOpen = box.hasAttribute('hidden');
        box.toggleAttribute('hidden', !willOpen); btn.setAttribute('aria-expanded', willOpen?'true':'false');
        if (willOpen) mod.querySelector('[data-dono-input]').focus();
        return; }
      if (e.target.closest('[data-dono-apply]')) { apply(mod); return; }
    }
    var step = e.target.closest('[data-cardqty-step]');
    if (step) {
      var box2 = step.closest('[data-cardqty]');
      var l0 = findLine(box2.getAttribute('data-cardqty'));
      if (l0) changeQty(l0, l0.q + parseInt(step.getAttribute('data-cardqty-step'), 10));
      return;
    }
    var row = e.target.closest('[data-line]');
    if (row) {
      var l = findLine(row.getAttribute('data-line'));
      if (e.target.closest('[data-demo-remove]')) { changeQty(l, 0); return; }
      var q = e.target.closest('[data-demo-qty]');
      if (q && l) { changeQty(l, l.q + (q.getAttribute('data-demo-qty')==='up'?1:-1)); return; }
    }
    /* "Mua ngay" trong ô xem nhanh: thêm rồi sang trang giỏ */
    var buy = e.target.closest('[data-qv-buy]');
    if (buy) {
      e.preventDefault();
      var meta0 = buy.getAttribute('data-demo-item');
      var form = buy.closest('form'); var qi = form && form.querySelector('[name="quantity"]');
      var qty = qi ? Math.max(1, parseInt(qi.value||'1',10)) : 1;
      try { var it0 = JSON.parse(meta0);
        if (it0.id) { addLine(it0.id, qty).then(function(){ window.location.href = CH.cart || '/cart'; }); return; }
      } catch(err){}
      window.location.href = CH.cart || '/cart';
      return;
    }
    var add = e.target.closest('[data-demo-add]');
    if (add) {
      var meta = add.getAttribute('data-demo-item');
      if (meta) { try { var it = JSON.parse(meta);
        if (add.classList.contains('qv__add')) {
          /* nút "Thêm vào giỏ" trong xem nhanh: theo số lượng đã chọn */
          var f2 = add.closest('form'); var q2 = f2 && f2.querySelector('[name="quantity"]');
          var n2 = q2 ? Math.max(1, parseInt(q2.value||'1',10)) : 1;
          var ex2 = findLine(it.k);
          if (ex2) { ex2.q += n2; render(); setLineQty(ex2, ex2.q); }
          else { var nl2 = {k:it.k,n:it.n,v:it.v,p:it.p,q:n2,id:it.id,key:''}; lines.push(nl2); render(); setLineQty(nl2, n2); }
        } else {
          if (add.classList.contains('addbtn')) expandQty(add, it.k, it.n);
          addByMeta(it);
        }
      } catch(err){} }
    }
  });
  function commitQty(input){
    var box = input.closest('[data-cardqty]'); if (!box) return;
    var ln = findLine(box.getAttribute('data-cardqty'));
    var v = parseInt(String(input.value).replace(/[^0-9]/g, ''), 10);
    if (!isFinite(v) || v < 0) v = ln ? ln.q : 1;
    if (v > 99) v = 99;
    if (ln) changeQty(ln, v);
  }
  document.addEventListener('change', function(e){
    var i = e.target.closest('[data-cardqty-num]'); if (i) { commitQty(i); return; }
    var j = e.target.closest('[data-demo-qty-input]');
    if (j) { var row = j.closest('[data-line]'); var l = row && findLine(row.getAttribute('data-line'));
      var v = parseInt(String(j.value).replace(/[^0-9]/g,''),10); if (!isFinite(v)||v<0) v = l? l.q : 1; if (v>99) v = 99;
      if (l) changeQty(l, v); }
  });
  document.addEventListener('blur', function(e){
    var i = e.target.closest && e.target.closest('[data-cardqty-num]'); if (i) commitQty(i);
  }, true);
  document.addEventListener('keydown', function(e){
    var i = e.target.closest && e.target.closest('[data-cardqty-num]');
    if (i && e.key === 'Enter') { e.preventDefault(); i.blur(); return; }
    if (e.key==='Enter' && e.target.closest('[data-dono-input]')) { e.preventDefault(); apply(e.target.closest('[data-donation]')); }
  });

  window.CHCart = { reload: reload, add: addLine, lines: function(){ return lines; }, render: render };

  document.addEventListener('DOMContentLoaded', function(){
    /* giỏ đã có sẵn trong trang (Liquid) -> không phải chờ mạng */
    if (CH.cartJson) { try { fromCart(CH.cartJson); } catch(e){} }
    render();
    var wait = false;
    new MutationObserver(function(recs){
      if (wait) return;
      var found = false;
      recs.forEach(function(r){
        [].forEach.call(r.addedNodes, function(n){
          if (found || n.nodeType !== 1) return;
          if ((n.matches && n.matches('.addbtn[data-demo-item]')) ||
              (n.querySelector && n.querySelector('.addbtn[data-demo-item]'))) found = true;
        });
      });
      if (!found) return;
      wait = true;
      requestAnimationFrame(function(){ wait = false; render(); });
    }).observe(document.body, { childList:true, subtree:true });
  });
})();



/* ---------- QUICK VIEW cho danh mục thật ----------
   51 SKU mới chưa có <template> tĩnh. Thay vì nhét 51 khối HTML gần giống nhau
   vào file, dựng template ngay khi bấm — QV.load() sẽ tìm thấy nó như bình thường. */
(function(){
  var D = (function(){ try { return JSON.parse(document.getElementById('chohem-D').textContent); } catch(e){ return {}; } })();
  var CH7 = (function(){ try { return JSON.parse(document.getElementById('chohem-CH').textContent); } catch(e){ return {}; } })();
  var ICON_SHIELD = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.1 19.2 6v5.7c0 4.2-2.9 7.6-7.2 9.2-4.3-1.6-7.2-5-7.2-9.2V6L12 3.1z"/><path d="m9.1 11.9 2.1 2.1 3.9-4.1"/></svg>';
  var ICON_CLOCK  = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M12 7v5.2l3.2 1.9"/></svg>';
  var ICON_TRUCK  = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M15 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M5 17h-2v-4m-1 -8h11v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"/><path d="M3 9l4 0"/></svg>';
  var ICON_ARROW  = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6"/></svg>';
  function esc(t){ return String(t).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }


  function money(c){ return c ? '$' + (c/100).toFixed(2) : 'Liên hệ'; }
  /* Gợi ý: cùng danh mục, bán chạy nhất, bỏ chính món đang xem.
     Thiếu thì lấy thêm món bán chạy ở danh mục khác cho đủ 4. */
  function related(handle){
    var me = D[handle]; if(!me) return '';
    var all = Object.keys(D).map(function(k){ var o = D[k]; o.h = k; return o; });
    function rank(a,b){ return b.so - a.so; }
    /* Món đã nằm trong giỏ thì loại khỏi danh sách gợi ý ngay từ lúc chọn,
       để hàng vẫn đủ 8 món trượt chứ không bị thủng lỗ. */
    function avail(o){ return o.h !== handle && !(window.CHInCart && window.CHInCart(o.h)); }
    var same  = all.filter(function(o){ return avail(o) && o.c === me.c; }).sort(rank);
    var other = all.filter(function(o){ return avail(o) && o.c !== me.c; }).sort(rank);
    /* Lấy 8 để hàng gợi ý có cái mà trượt; 4 hiện, bấm mũi tên ra 4 món sau. */
    var pick = same.concat(other).slice(0,8);
    if(!pick.length) return '';
    return '<section class="rel"><h3 class="rel__title">Có thể bạn sẽ thích</h3>' +
      '<div class="crow crow--rel" data-crow>' +
      '<button class="crow__arrow crow__arrow--prev" type="button" data-crow-prev aria-label="Xem sản phẩm phía trước"><svg width=\"13\" height=\"13\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 6l-6 6 6 6\"/></svg></button>' +
      '<div class="rel__grid">' +
      pick.map(function(o){
        var item = JSON.stringify({k:o.h, n:o.n, v:o.v, p:o.p||0, id:o.id}).replace(/'/g,'&#39;');
        return '<div class="rel__card">' +
          '<div class="rel__mediabox">' +
            '<a class="rel__media" href="' + (o.url || '#') + '" data-quick-view="' + o.h + '" tabindex="-1" aria-hidden="true">' +
              '<img data-img="' + o.h + '" alt=""></a>' +
            (o.p && o.avail !== false ? '<button class="addbtn" type="button" aria-label="Thêm ' + esc(o.n) + ' vào giỏ" ' +
              'data-demo-add data-demo-item=\'' + item + '\'><span aria-hidden="true">+</span></button>' : '') +
          '</div>' +
          '<a class="rel__body" href="' + (o.url || '#') + '" data-quick-view="' + o.h + '">' +
            '<span class="rel__name">' + esc(o.n) + '</span>' +
            '<span class="rel__meta">' + esc(o.v) + '</span>' +
            '<span class="rel__foot">' + '<span class="rel__price">' + money(o.p) + '</span>' +
            '<span class="rel__sold">' + (o.so ? 'Đã bán ' + o.so : 'Sản phẩm mới') + '</span></span></a>' +
        '</div>';
      }).join('') + '</div>' +
      '<button class="crow__arrow crow__arrow--next" type="button" data-crow-next aria-label="Xem sản phẩm tiếp theo"><svg width=\"13\" height=\"13\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M9 6l6 6-6 6\"/></svg></button>' +
      '</div></section>';
  }

  function build(handle){
    var d = D[handle]; if(!d) return null;
    var n = esc(d.n), v = esc(d.v);
    var t = document.createElement('template');
    t.id = 'qv-' + handle;
    t.innerHTML =
      '<div class="qv__content" data-qv-content><div class="qv__main">' +
        (function(){
          var list = d.md || [];   /* theme: Liquid sinh từ product.media (chohem-data.liquid) */
          var th = list.map(function(m, k){
            var kind = m.t === 'vid' ? 'video' : 'image';
            var full = m.t === 'vid' ? m.v : (m.s || '');
            var poster = m.t === 'vid' ? m.p : '';
            var img = m.t === 'vid' ? '<img src="' + (m.th || poster) + '" alt="">' : (m.k ? '<img data-img="' + m.k + '" alt="">' : '<img src="' + (m.th || m.s) + '" alt="">');
            return '<button type="button" class="qv__thumb' + (kind === 'video' ? ' qv__thumb--video' : '') + (k === 0 ? ' is-active' : '') + '" data-qv-thumb data-kind="' + kind + '"' +
              (m.k ? ' data-full-key="' + m.k + '"' : ' data-full="' + full + '"') + (poster ? ' data-poster="' + poster + '"' : '') +
              ' aria-label="' + (kind === 'video' ? 'Video' : 'Ảnh') + ' ' + (k + 1) + '">' + img + (kind === 'video' ? '<span class="qv__play" aria-hidden="true">&#9654;</span>' : '') + '</button>';
          }).join('');
          return '<div class="qv__gallery" data-qv-gallery tabindex="0"><div class="qv__stage">' +
            '<img data-qv-stage data-img="' + handle + '" alt="' + n + '">' +
            '<video class="qv__video" data-qv-video muted playsinline loop controls preload="none" hidden></video>' +
            (list.length > 1 ? '<button type="button" class="qv__navarrow qv__navarrow--prev" data-qv-prev aria-label="Ảnh trước"><svg width=\"13\" height=\"13\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M15 6l-6 6 6 6\"/></svg></button><button type="button" class="qv__navarrow qv__navarrow--next" data-qv-next aria-label="Ảnh sau"><svg width=\"13\" height=\"13\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M9 6l6 6-6 6\"/></svg></button>' : '') +
            '</div>' + (list.length > 1 ? '<div class="qv__thumbs" data-qv-thumbs>' + th + '</div>' : '') + '</div>';
        })() +
        '<div class="qv__info">' +
          '<h2 class="qv__title editorial-title" id="qv-title">' + n + '</h2>' +
          '<p class="qv__subtitle" data-qv-variant-label>' + v + '</p>' +
          '<div class="qv__price" data-qv-price><span class="qv__price-now' + (d.o ? ' price__now--sale' : '') + '">' + (d.p ? '$'+(d.p/100).toFixed(2) : 'Liên hệ') + '</span>' + (d.o ? '<s class="price__old">$'+(d.o/100).toFixed(2)+'</s>' : '') + '</div>' +
          '<ul class="qv__benefits">' +
            '<li>' + ICON_SHIELD + '<span>Chính hãng 100%</span></li>' +
            '<li>' + ICON_CLOCK  + '<span>Hạn sử dụng dài</span></li>' +
            '<li>' + ICON_TRUCK  + '<span>Giao nhanh 2–4 ngày</span></li>' +
          '</ul>' +
          '<form class="qv__form" data-qv-form>' + (d.p ? '<div class="qv__buyrow"><div class="qv__qty">' +
            '<span class="qv__label" id="qv-qty-label">Số lượng</span>' +
            '<div class="qty qty--qv"><button type="button" data-qty="down" aria-label="Giảm">&minus;</button>' +
            '<input type="number" name="quantity" value="1" min="1" aria-labelledby="qv-qty-label">' +
            '<button type="button" data-qty="up" aria-label="Tăng">+</button></div></div>' +
            '<p class="qv__stock" data-qv-stock><span class="qv__dot"></span>Còn hàng</p></div>' : '') +
            (!d.p ?
              '<div class="qv__actions qv__actions--ask">' +
                '<a class="qv__ask" href="' + (CH7.lienhe || '/pages/lien-he') + '" data-qv-ask>Liên hệ để đặt hàng</a>' +
              '</div>'
            :
            '<div class="qv__actions">' +
              '<button class="qv__add" type="button" data-qv-add data-demo-add ' +
                'data-demo-item=\'' + JSON.stringify({k:handle,n:d.n,v:d.v,p:d.p||0,id:d.id}).replace(/'/g,'&#39;') + '\'>' +
                '<span data-qv-add-text data-vi="Thêm vào giỏ">Thêm vào giỏ</span>' + ICON_ARROW + '</button>' +
              '<a class="qv__buy" href="' + (CH7.cart || '/cart') + '" data-qv-buy data-demo-add ' +
                'data-demo-item=\'' + JSON.stringify({k:handle,n:d.n,v:d.v,p:d.p||0,id:d.id}).replace(/'/g,'&#39;') + '\'>Mua ngay</a>' +
            '</div>') + '</form>' +
        '</div></div>' +
        '<div class="qv__doc"><div class="acc acc--editorial">' +
          /* Thông tin sản phẩm đứng TRƯỚC Mô tả sản phẩm */
          '<section class="acc__item is-open"><h3><button class="acc__btn" type="button" aria-expanded="true">' +
            'Thông tin sản phẩm<i class="acc__sign"></i></button></h3><div class="acc__panel">' +
            '<dl class="qv__dl"><dt>Mã sản phẩm</dt><dd>' + esc(d.sku) + '</dd>' +
            '<dt>Thương hiệu</dt><dd>Chợ Hẻm</dd><dt>Xuất xứ</dt><dd>Việt Nam</dd>' +
            '<dt>Quy cách</dt><dd>' + v + '</dd></dl></div></section>' +
          '<section class="acc__item is-open"><h3><button class="acc__btn" type="button" aria-expanded="true">' +
            'Mô tả sản phẩm<i class="acc__sign"></i></button></h3><div class="acc__panel">' +
            '<div class="rte qv__prose">' + (d.desc ? d.desc : '<p>Đang cập nhật mô tả cho ' + n + '.</p>') + '</div></div></section>' +
        '</div></div>' + related(handle) +
      '</div>';
    document.body.appendChild(t);
    return t;
  }
  /* chạy TRƯỚC listener của QV nên template luôn sẵn sàng khi QV đi tìm */
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-add-form],[data-demo-add],.addbtn')) return;
    var t = e.target.closest('[data-quick-view]'); if(!t) return;
    var h = t.getAttribute('data-quick-view');
    if(!document.getElementById('qv-' + h)) build(h);
  });
})();



/* Chợ Hẻm — theme scripts. Vanilla, không phụ thuộc thư viện. */
(function () {
  'use strict';

  var money = function (cents) {
    try {
      var fmt = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: fmt }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* ---------- Drawer danh mục (mobile) ---------- */
  function initDrawer() {
    var open = document.querySelector('[data-drawer-open]');
    var closers = document.querySelectorAll('[data-drawer-close]');
    if (!open) return;
    var setState = function (on) {
      document.body.classList.toggle('drawer-open', on);
      open.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { var f = document.querySelector('.sidebar a'); if (f) f.focus(); } else { open.focus(); }
    };
    open.addEventListener('click', function () { setState(!document.body.classList.contains('drawer-open')); });
    closers.forEach(function (el) { el.addEventListener('click', function () { setState(false); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('drawer-open')) setState(false);
    });
  }

  /* ---------- Hero slider ---------- */
  function initHero() {
    document.querySelectorAll('[data-hero]').forEach(function (hero) {
      var track = hero.querySelector('[data-hero-track]');
      var slides = hero.querySelectorAll('[data-hero-slide]');
      var dots = hero.querySelectorAll('[data-hero-dot]');
      if (!track || slides.length < 2) return;

      var i = 0, timer = null;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var interval = parseInt(hero.getAttribute('data-interval') || '6000', 10);

      function go(n) {
        i = (n + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-100 * i) + '%)';
        dots.forEach(function (d, k) {
          d.classList.toggle('is-active', k === i);
          d.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
        slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      }
      function play() { if (reduce) return; stop(); timer = setInterval(function () { go(i + 1); }, interval); }
      function stop() { if (timer) clearInterval(timer); timer = null; }

      var prev = hero.querySelector('[data-hero-prev]');
      var next = hero.querySelector('[data-hero-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
      if (next) next.addEventListener('click', function () { go(i + 1); play(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-hero-dot'), 10)); play(); });
      });
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', play);
      hero.addEventListener('focusin', stop);

      /* vuốt trên mobile */
      var x0 = null;
      hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 42) go(dx < 0 ? i + 1 : i - 1);
        x0 = null; play();
      });

      go(0);
      if (hero.getAttribute('data-autoplay') !== 'false') play();
    });
  }

  /* ---------- Thêm giỏ: báo bằng CHỮ, không dùng ký hiệu ✓ ----------
     Ghi lại chữ tiếng Việt gốc rồi trả về đúng chữ đó, để bộ chuyển ngôn ngữ
     tự dịch sang tiếng Anh — không bị kẹt lại tiếng Anh khi bấm về VI. */
  var ADDED_TEXT = 'Đã thêm vào giỏ';
  function flash(btn) {
    var icon = btn.querySelector('[data-qv-add-text]') || btn.querySelector('[data-add-icon]')
            || btn.firstElementChild || btn;
    if (icon.__busy) return;
    var vi = icon.getAttribute && icon.getAttribute('data-vi');
    if (!vi) { vi = icon.textContent; if (icon.setAttribute) icon.setAttribute('data-vi', vi); }
    icon.__busy = true;
    btn.classList.add('is-added');
    icon.textContent = ADDED_TEXT;
    setTimeout(function () {
      btn.classList.remove('is-added');
      icon.textContent = vi || '+';
      icon.__busy = false;
    }, 1000);
  }

  function bumpCartCount(count) {
    document.querySelectorAll('.action').forEach(function (a) {
      if (!a.getAttribute('href') || a.getAttribute('href').indexOf('cart') === -1) return;
      var badge = a.querySelector('.action__count');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'action__count';
        (a.querySelector('.action__icon') || a).appendChild(badge);
      }
      badge.textContent = count;
    });
  }

  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-add-form]');
      if (!form) return;
      e.preventDefault();
      e.stopPropagation();
      var btn = form.querySelector('[data-add-btn]');
      if (!btn || btn.disabled) return;
      btn.disabled = true;

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: form.querySelector('[name="id"]').value, quantity: 1 }]
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          flash(btn);
          return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          bumpCartCount(cart.item_count);
          if (window.CHCart) window.CHCart.reload();
          if (typeof Cart !== 'undefined' && !document.querySelector('[data-cart-page]')) { Cart.open(btn); }
        })
        .catch(function () { form.submit(); })
        .finally(function () { btn.disabled = false; });
    });

    /* nút demo khi chưa gán collection */
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-demo-add]');
      if (!b) return;
      e.stopPropagation();
      /* Nút [+] trên thẻ giờ nở thành bộ đếm nên không nháy ✓ nữa.
         Nếu vẫn nháy, bộ hẹn giờ 1 giây của nó có thể sống lâu hơn bộ đếm:
         khách bớt về 0 trong vòng 1 giây thì nút hiện lại kèm dấu ✓ còn sót. */
      if (b.classList.contains('addbtn')) return;
      flash(b);
    });
  }

  /* ---------- Đăng ký nhận tin ----------
     Bản preview báo ngay tại chỗ. Theme thật nối vào Shopify customer form. */
  function initNewsletter() {
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-newsletter],.newsletter__form');
      if (!f) return;
      var input = f.querySelector('.newsletter__input');
      var note = f.parentElement.querySelector('[data-nl-note]');
      var v = (input.value || '').trim();
      var ok = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(v);
      if (note) {
        note.textContent = ok ? 'Cảm ơn bạn! Chợ Hẻm sẽ gửi tin sớm nhất.' : 'Email chưa đúng, bạn kiểm tra lại giúp nhé.';
        note.style.color = ok ? '' : 'var(--brand-orange)';
        note.hidden = false;
      }
      if (!ok) { e.preventDefault(); input.focus(); }
    });
  }

  /* ---------- "Mua ngay": đóng quick view rồi sang trang giỏ hàng ----------
     Trên theme thật, chỗ này nên POST /cart/add.js rồi chuyển thẳng tới /checkout. */
  function initBuyNow() {
    document.addEventListener('click', function (e) {
      var pb = e.target.closest('[data-pdp-buy]');
      if (pb) { var pf = pb.closest('form'); if (pf) { var idEl = pf.querySelector('[name="id"]:not([type=hidden])') || pf.querySelector('[name="id"]'); var qEl = pf.querySelector('[name="quantity"]');
        if (window.CHCart && idEl) { pb.disabled = true; window.CHCart.add(idEl.value, qEl ? Math.max(1, parseInt(qEl.value||'1',10)) : 1).then(function(){ window.location.href = (window.CH_ROUTES && window.CH_ROUTES.cart) || '/cart'; }); return; } } }
      var b = e.target.closest('[data-qv-buy]');
      if (!b) return;
      if (window.CHCart) return;   /* modul gio that lo */
      var qv = b.closest('.qv');
      var close = qv && qv.querySelector('[data-qv-close]');
      if (close) close.click();
    });
  }

  /* ---------- Số lượng ---------- */
  function initQty() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]');
      if (!b) return;
      var input = b.parentElement.querySelector('input');
      if (!input) return;
      var v = parseInt(input.value || '1', 10);
      v = b.getAttribute('data-qty') === 'up' ? v + 1 : Math.max(1, v - 1);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Accordion PDP ---------- */
  function initAccordion() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('.acc__btn');
      if (!b) return;
      var item = b.closest('.acc__item');
      var isOpen = item.classList.toggle('is-open');
      b.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* ---------- Gallery PDP ---------- */
  function initGallery() {   /* trang sản phẩm = ô xem nhanh dựng thành trang → dùng đúng gallery của v122 */
    var g = document.querySelector('[data-gallery]');
    if (!g) return;
    if (window.CHFixImg) window.CHFixImg(g);   /* gán data-full từ data-full-key trước khi đọc */
    var stage = g.querySelector('[data-qv-stage]');
    var vid = g.querySelector('[data-qv-video]');
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-qv-thumb]'));
    var i = 0;
    function stopVideo() { if (vid && !vid.hidden) { vid.pause(); vid.hidden = true; } if (stage) stage.hidden = false; }
    function go(n) {
      if (!thumbs.length) return;
      i = (n + thumbs.length) % thumbs.length;
      var t = thumbs[i], src = t.getAttribute('data-full'), kind = t.getAttribute('data-kind') || 'image';
      stopVideo();
      if (kind === 'video' && vid && src) {
        if (stage) stage.hidden = true;
        vid.hidden = false; vid.muted = true;
        if (vid.getAttribute('src') !== src) { vid.setAttribute('src', src); vid.setAttribute('poster', t.getAttribute('data-poster') || ''); vid.load(); }
        var p = vid.play(); if (p && p.catch) p.catch(function () {});
      } else if (stage && src) { stage.removeAttribute('srcset'); stage.src = src; }
      thumbs.forEach(function (x, k) {
        x.classList.toggle('is-active', k === i);
        x.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      if (t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      warm(i + 1);
    }
    /* NẠP SẴN: ảnh 900px chỉ được tải khi bấm next -> trễ 0,6–0,9 s lần đầu (đo trên chohem.com).
       Mở ô là tải ngầm hết ảnh (ưu tiên thấp), video chỉ nạp khi ô kế bên là video. */
    function warm(n) {
      var t = thumbs[(n + thumbs.length) % thumbs.length]; if (!t) return;
      var src = t.getAttribute('data-full');
      if ((t.getAttribute('data-kind') || 'image') === 'video' && vid && src && vid.getAttribute('src') !== src) {
        vid.setAttribute('src', src); vid.setAttribute('poster', t.getAttribute('data-poster') || ''); vid.preload = 'auto'; vid.load();
      }
    }
    thumbs.forEach(function (t) {
      if ((t.getAttribute('data-kind') || 'image') === 'video') return;
      var src = t.getAttribute('data-full'); if (!src || t.__pre) return;
      var im = new Image(); try { im.fetchPriority = 'low'; } catch (e) {} im.decoding = 'async'; im.src = src; t.__pre = im;
    });
    warm(1);
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = g.querySelector('[data-qv-prev]'), next = g.querySelector('[data-qv-next]');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(i - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(i + 1); });
    var x0 = null, st = g.querySelector('.qv__stage') || g;
    st.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    st.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); }, { passive: true });
    g.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); } if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); } });
    }

  /* ---------- Variant picker PDP ---------- */
  function initVariants() {
    document.querySelectorAll('[data-variants]').forEach(function (root) {
      var data = null;
      try { data = JSON.parse(root.querySelector('[data-variant-json]').textContent); } catch (e) { return; }
      var idInput = root.querySelector('[name="id"]');
      var priceEl = root.querySelector('[data-pdp-price]');
      var subBtn = root.querySelector('[data-pdp-submit]');

      root.querySelectorAll('[data-variant-pill]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var vid = pill.getAttribute('data-variant-pill');
          root.querySelectorAll('[data-variant-pill]').forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          if (idInput) idInput.value = vid;

          var v = data.filter(function (x) { return String(x.id) === String(vid); })[0];
          if (!v) return;
          if (priceEl) {
            priceEl.innerHTML = '<span class="price__now">' + money(v.price) + '</span>' +
              (v.compare_at_price > v.price ? '<s class="price__was">' + money(v.compare_at_price) + '</s>' : '');
            priceEl.className = 'price pdp__price' + (v.compare_at_price > v.price ? ' price--sale' : '');
          }
          if (subBtn) {
            subBtn.disabled = !v.available;
            subBtn.textContent = v.available ? 'Thêm vào giỏ' : 'Tạm hết hàng';
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', vid);
          window.history.replaceState({}, '', url);
        });
      });
    });
  }


  /* ---------- QUICK VIEW ---------- */
  var QV = (function () {
    var root, dialog, body, scroll, lastFocus = null, cache = {}, open = false, gallery = null;

    function el() {
      root = document.querySelector('[data-qv]');
      if (!root) return false;
      dialog = root.querySelector('.qv__dialog');
      body = root.querySelector('[data-qv-body]');
      scroll = root.querySelector('[data-qv-scroll]');
      return true;
    }

    function focusables() {
      return Array.prototype.filter.call(
        dialog.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'),
        function (n) { return n.offsetParent !== null || n === document.activeElement; });
    }

    function trap(e) {
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function onKey(e) {
      if (!open) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else trap(e);
    }

    function lock() {
      var sb = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      if (sb > 0) document.body.style.paddingRight = sb + 'px';
    }
    function unlock() { document.body.style.overflow = ''; document.body.style.paddingRight = ''; }

    var closeSeq = 0;

    function show() {
      closeSeq++;              /* huỷ lần đóng đang chờ, nếu mở lại thật nhanh */
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      open = true; lock();
      document.addEventListener('keydown', onKey);
    }

    function close() {
      if (!open) return;
      open = false;
      root.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      /* unlock() phải chạy CÙNG LÚC với root.hidden. Trước đây nó chạy ngay,
         nên thanh cuộn trang hiện lại trong khi .qv vẫn còn 220ms nữa mới ẩn —
         hai thanh cuộn đứng cạnh nhau suốt quãng đó. */
      var seq = ++closeSeq;
      var done = function () {
        if (seq !== closeSeq || open) return;   /* đã mở lại trong lúc chờ */
        root.hidden = true;
        unlock();
        body.innerHTML = '<p class="qv__loading" data-qv-loading>Đang tải…</p>';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      };
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) done(); else setTimeout(done, 220);
    }

    function inject(html) {
      body.innerHTML = html;
      dialog.setAttribute('aria-busy', 'false');
      if (scroll) scroll.scrollTop = 0;
      initGallery();
      initVariants();
      var first = body.querySelector('.qv__swatch, [data-qv-add]');
      if (first) first.focus({ preventScroll: true });
    }

    /* gallery: click thumb / mũi tên; không autoplay */
    function initGallery() {
      var g = body.querySelector('[data-qv-gallery]');
      if (!g) return;
      if (window.CHFixImg) window.CHFixImg(g);   /* gán data-full từ data-full-key trước khi đọc */
      var stage = g.querySelector('[data-qv-stage]');
      var vid = g.querySelector('[data-qv-video]');
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-qv-thumb]'));
      var i = 0;
      function stopVideo() { if (vid && !vid.hidden) { vid.pause(); vid.hidden = true; } if (stage) stage.hidden = false; }
      function go(n) {
        if (!thumbs.length) return;
        i = (n + thumbs.length) % thumbs.length;
        var t = thumbs[i], src = t.getAttribute('data-full'), kind = t.getAttribute('data-kind') || 'image';
        stopVideo();
        if (kind === 'video' && vid && src) {
          if (stage) stage.hidden = true;
          vid.hidden = false; vid.muted = true;
          if (vid.getAttribute('src') !== src) { vid.setAttribute('src', src); vid.setAttribute('poster', t.getAttribute('data-poster') || ''); vid.load(); }
          var p = vid.play(); if (p && p.catch) p.catch(function () {});
        } else if (stage && src) { stage.removeAttribute('srcset'); stage.src = src; }
        thumbs.forEach(function (x, k) {
          x.classList.toggle('is-active', k === i);
          x.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
        if (t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        warm(i + 1);
      }
      /* NẠP SẴN: ảnh 900px chỉ được tải khi bấm next -> trễ 0,6–0,9 s lần đầu (đo trên chohem.com).
         Mở ô là tải ngầm hết ảnh (ưu tiên thấp), video chỉ nạp khi ô kế bên là video. */
      function warm(n) {
        var t = thumbs[(n + thumbs.length) % thumbs.length]; if (!t) return;
        var src = t.getAttribute('data-full');
        if ((t.getAttribute('data-kind') || 'image') === 'video' && vid && src && vid.getAttribute('src') !== src) {
          vid.setAttribute('src', src); vid.setAttribute('poster', t.getAttribute('data-poster') || ''); vid.preload = 'auto'; vid.load();
        }
      }
      thumbs.forEach(function (t) {
        if ((t.getAttribute('data-kind') || 'image') === 'video') return;
        var src = t.getAttribute('data-full'); if (!src || t.__pre) return;
        var im = new Image(); try { im.fetchPriority = 'low'; } catch (e) {} im.decoding = 'async'; im.src = src; t.__pre = im;
      });
      warm(1);
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var prev = g.querySelector('[data-qv-prev]'), next = g.querySelector('[data-qv-next]');
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(i - 1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(i + 1); });
      var x0 = null, st = g.querySelector('.qv__stage') || g;
      st.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      st.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); }, { passive: true });
      g.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); } if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); } });
      gallery = { go: go, thumbs: thumbs };
    }

    /* variant: chọn theo option thật của sản phẩm */
    function initVariants() {
      var groups = Array.prototype.slice.call(body.querySelectorAll('[data-qv-option-group]'));
      if (!groups.length) return;
      var json = body.querySelector('[data-qv-variants]');
      var data = null;
      if (json) { try { data = JSON.parse(json.textContent); } catch (e) { data = null; } }
      var idInput = body.querySelector('[data-qv-variant-id]');
      var priceEl = body.querySelector('[data-qv-price]');
      var stockEl = body.querySelector('[data-qv-stock]');
      var addBtn = body.querySelector('[data-qv-add]');
      var addTxt = body.querySelector('[data-qv-add-text]');
      var labelEl = body.querySelector('[data-qv-variant-label]');
      var skuEl = body.querySelector('[data-qv-sku]');

      function chosen() {
        return groups.map(function (g) {
          var a = g.querySelector('.qv__swatch.is-active');
          return a ? a.getAttribute('data-qv-option-value') : null;
        });
      }
      function match(opts) {
        return data.filter(function (v) {
          return opts.every(function (o, k) { return o === null || v.options[k] === o; });
        })[0];
      }
      function paint() {
        if (!data) return;
        var v = match(chosen());
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl) {
          var sale = v.compare_at_price > v.price;
          priceEl.className = 'qv__price' + (sale ? ' qv__price--sale' : '');
          priceEl.innerHTML = '<span class="qv__price-now">' + money(v.price) + '</span>' +
            (sale ? '<s class="qv__price-was">' + money(v.compare_at_price) + '</s>' : '');
        }
        if (stockEl) {
          stockEl.classList.toggle('is-out', !v.available);
          stockEl.innerHTML = '<span class="qv__dot" aria-hidden="true"></span>' + (v.available ? 'Còn hàng' : 'Tạm hết hàng');
        }
        if (addBtn) addBtn.disabled = !v.available;
        if (addTxt) addTxt.textContent = v.available ? 'Thêm vào giỏ' : 'Tạm hết hàng';
        if (labelEl && v.title && v.title !== 'Default Title') labelEl.textContent = v.title;
        if (skuEl && v.sku) skuEl.textContent = v.sku;
        if (v.featured && gallery) {
          var stage = body.querySelector('[data-qv-stage]');
          if (stage) { stage.removeAttribute('srcset'); stage.src = v.featured; }
        }
      }
      groups.forEach(function (g) {
        g.addEventListener('click', function (e) {
          var b = e.target.closest('.qv__swatch');
          if (!b || b.disabled) return;
          g.querySelectorAll('.qv__swatch').forEach(function (x) {
            x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false');
          });
          b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
          paint();
        });
      });
      paint();
    }

    /* nạp nội dung: ưu tiên <template> có sẵn (bản preview tĩnh),
       còn lại lấy từ Shopify Section Rendering API rồi cache lại */
    function load(handle) {
      var tpl = document.getElementById('qv-' + handle);
      if (tpl) return Promise.resolve(tpl.innerHTML);
      if (cache[handle]) return Promise.resolve(cache[handle]);
      var base = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      return fetch(base + 'products/' + handle + '?section_id=quick-view')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var d = document.createElement('div'); d.innerHTML = html;
          var c = d.querySelector('[data-qv-content]');
          var out = c ? c.outerHTML : html;
          cache[handle] = out;
          return out;
        });
    }

    function openFor(handle, trigger, fallbackUrl) {
      if (!root && !el()) return false;
      lastFocus = trigger || document.activeElement;
      dialog.setAttribute('aria-busy', 'true');
      show();
      load(handle)
        .then(inject)
        .catch(function () { if (fallbackUrl) window.location.href = fallbackUrl; else close(); });
      return true;
    }

    function init() {
      if (!el()) return;
      root.addEventListener('click', function (e) {
        /* e.target === root: bấm vào vùng nền mờ quanh hộp sản phẩm */
        if (e.target === root || e.target.closest('[data-qv-close]')) { e.preventDefault(); close(); }
      });
      /* mở từ ảnh hoặc tên sản phẩm; nút [+] không kích hoạt (xem initAddToCart) */
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-add-form],[data-demo-add],.addbtn')) return;
        var t = e.target.closest('[data-quick-view]');
        if (!t) return;
        e.preventDefault();
        openFor(t.getAttribute('data-quick-view'), t, t.getAttribute('href'));
      });
    }
    return { init: init, open: openFor, close: close };
  })();


  /* ---------- CART DRAWER + DONATION ----------
     Donation là một line item của sản phẩm giá $1, số lượng = số tiền.
     Nhờ vậy trạng thái tự đồng bộ giữa drawer / trang giỏ / checkout,
     và khi số tiền = 0 thì dòng đó bị xoá hẳn — không có line item $0 nào tồn tại.
     KHÔNG có tuỳ chọn "không ủng hộ": không bấm = không ủng hộ.            */
  var Cart = (function () {
    var root, panel, lastFocus = null, open = false, busy = false;
    function base() { return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'); }
    /* Ngoài Shopify (bản preview tĩnh) thì không gọi API giỏ hàng —
       chỉ giữ phần mở/đóng drawer, số liệu do trang demo tự quản. */
    function live() { return !!(window.Shopify && window.Shopify.routes); }

    function el() {
      root = document.querySelector('[data-cart-drawer]');
      if (!root) return false;
      panel = root.querySelector('[data-cart-panel]') || root.querySelector('.cdw__panel');
      if (!panel) return false;
      return true;
    }
    function focusables() {
      return Array.prototype.filter.call(
        panel.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'),
        function (n) { return n.offsetParent !== null; });
    }
    function onKey(e) {
      if (!open) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function lock() {
      var sb = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      if (sb > 0) document.body.style.paddingRight = sb + 'px';
    }
    function unlock() { document.body.style.overflow = ''; document.body.style.paddingRight = ''; }

    function show(trigger) {
      if (!root && !el()) return;
      lastFocus = trigger || document.activeElement;
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      open = true; lock();
      document.addEventListener('keydown', onKey);
      var c = panel && panel.querySelector('[data-cart-close]');
      if (c) c.focus({ preventScroll: true });
    }
    function close() {
      if (!open) return;
      open = false;
      root.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      unlock();
      setTimeout(function () {
        root.hidden = true;
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }, 260);
    }

    /* nạp lại nội dung drawer + tóm tắt của trang giỏ sau mỗi thay đổi */
    function refresh() {
      if (window.CHCart) return window.CHCart.reload();
      if (!live()) return Promise.resolve();
      var jobs = [fetch(base() + '?section_id=cart-drawer').then(function (r) { return r.text(); })];
      var onPage = document.querySelector('[data-cart-page]');
      if (onPage) jobs.push(fetch(base() + 'cart?section_id=main-cart').then(function (r) { return r.text(); }));
      return Promise.all(jobs).then(function (res) {
        var d = document.createElement('div'); d.innerHTML = res[0];
        var fresh = d.querySelector('[data-cart-drawer-content]');
        var cur = panel ? panel.querySelector('[data-cart-drawer-content]') : null;
        if (fresh && cur) cur.replaceWith(fresh);
        if (fresh) bumpCartCount(parseInt(fresh.getAttribute("data-cart-count") || "0", 10));
        if (res[1]) {
          var d2 = document.createElement('div'); d2.innerHTML = res[1];
          var f2 = d2.querySelector('[data-cart-page]');
          if (f2 && onPage) onPage.replaceWith(f2);
          else if (!f2) window.location.reload();
        }
      });
    }

    function post(url, payload) {
      if (!live() || busy) return Promise.resolve();
      busy = true;
      if (panel) panel.setAttribute('aria-busy', 'true');
      return fetch(base() + url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) { return r.json(); })
        .then(refresh)
        .catch(function () { window.location.href = base() + 'cart'; })
        .finally(function () { busy = false; if (panel) panel.setAttribute('aria-busy', 'false'); });
    }

    function changeLine(key, qty) { return post('cart/change.js', { id: key, quantity: qty }); }

    /* --- donation --- */
    function donoState(mod) {
      return {
        amount: parseInt(mod.getAttribute('data-amount') || '0', 10),
        key: mod.getAttribute('data-line-key') || '',
        vid: mod.getAttribute('data-variant-id') || ''
      };
    }
    function setDonation(mod, amount) {
      var st = donoState(mod);
      if (!st.vid && !st.key) return Promise.resolve();   /* chưa cấu hình sản phẩm ủng hộ */
      amount = Math.floor(Number(amount));
      if (!isFinite(amount) || amount < 0) amount = 0;
      if (amount === st.amount) return Promise.resolve();
      if (st.key) return changeLine(st.key, amount);            /* 0 => Shopify xoá dòng */
      if (amount === 0) return Promise.resolve();               /* chưa có dòng nào, không tạo dòng $0 */
      return post('cart/add.js', { items: [{ id: st.vid, quantity: amount }] });
    }

    function initDonation(scope) {
      scope.addEventListener('click', function (e) {
        /* Bản preview tĩnh đã có bộ xử lý riêng cho khối ủng hộ. Hai bộ cùng
           bật/tắt một ô -> bật rồi tắt ngay, bấm mà không thấy gì hiện ra.
           Preview thắng ở đây; trên store thật cờ này không tồn tại nên
           đoạn dưới chạy bình thường. */
        if (window.CHPreviewCart) return;
        var mod = e.target.closest('[data-donation]');
        if (!mod) return;

        var amt = e.target.closest('[data-dono-amt]');
        if (amt) {
          e.preventDefault();
          var val = parseInt(amt.getAttribute('data-dono-amt'), 10);
          var cur = donoState(mod).amount;
          setDonation(mod, cur === val ? 0 : val);   /* bấm lại chính nó => bỏ chọn */
          return;
        }
        if (e.target.closest('[data-dono-other]')) {
          e.preventDefault();
          var box = mod.querySelector('[data-dono-custom]');
          var btn = mod.querySelector('[data-dono-other]');
          var willOpen = box.hasAttribute('hidden');
          box.toggleAttribute('hidden', !willOpen);
          btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          if (willOpen) { var i = box.querySelector('[data-dono-input]'); if (i) i.focus(); }
          return;
        }
        if (e.target.closest('[data-dono-apply]')) {
          e.preventDefault();
          applyCustom(mod);
        }
      });
      scope.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        var i = e.target.closest('[data-dono-input]');
        if (!i) return;
        e.preventDefault();
        applyCustom(i.closest('[data-donation]'));
      });
    }
    function applyCustom(mod) {
      if (!mod) return;
      var input = mod.querySelector('[data-dono-input]');
      var hint = mod.querySelector('[data-dono-hint]');
      var raw = (input.value || '').trim();
      function warn(msg) { if (hint) { hint.textContent = msg; hint.hidden = false; } }
      if (hint) hint.hidden = true;
      if (raw === '') { setDonation(mod, 0); return; }          /* xoá trắng => quay về 0 */
      var n = Number(raw);
      if (!isFinite(n) || isNaN(n) || n <= 0) { warn('Nhập số tiền lớn hơn 0.'); return; }
      if (Math.floor(n) !== n) { warn('Chỉ nhận số tiền chẵn (1, 2, 3…).'); return; }
      setDonation(mod, n);
    }

    function init() {
      if (!el()) return;
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); }
      });
      /* mở drawer từ icon giỏ */
      document.addEventListener('click', function (e) {
        var t = e.target.closest('a[href$="/cart"],a[href*="/cart?"],[data-cart-open]');
        if (!t) return;
        if (t.hasAttribute('data-no-drawer')) return;
        if (document.querySelector('[data-cart-page]')) return;   /* đang ở trang giỏ thì không mở */
        e.preventDefault();
        show(t);
        refresh();
      });
      /* số lượng + xoá, dùng chung cho drawer và trang giỏ */
      document.addEventListener('click', function (e) {
        var row = e.target.closest('[data-line-key]');
        if (!row) return;
        var key = row.getAttribute('data-line-key');
        var rm = e.target.closest('[data-cart-remove]');
        if (rm) { e.preventDefault(); changeLine(key, 0); return; }
        var q = e.target.closest('[data-cart-qty]');
        if (!q) return;
        e.preventDefault();
        var input = row.querySelector('[data-cart-qty-input]');
        var v = parseInt(input.value || '1', 10);
        v = q.getAttribute('data-cart-qty') === 'up' ? v + 1 : v - 1;
        if (v < 0) v = 0;
        changeLine(key, v);
      });
      document.addEventListener('change', function (e) {
        var input = e.target.closest('[data-cart-qty-input]');
        if (!input) return;
        var row = input.closest('[data-line-key]');
        var v = parseInt(input.value || '0', 10);
        if (!isFinite(v) || v < 0) v = 0;
        changeLine(row.getAttribute('data-line-key'), v);
      });
      initDonation(document);
    }
    return { init: init, open: show, close: close, refresh: refresh };
  })();


  /* ---------- ĐÁNH GIÁ: lọc theo sao + xem thêm ---------- */
  function initReviews() {
    var root = document.querySelector('[data-reviews]');
    if (!root) return;
    var grid = root.querySelector('[data-rev-grid]');
    if (!grid) return;
    var items = [].slice.call(grid.querySelectorAll('[data-rev-item]'));
    var more = root.querySelector('[data-rev-more]');
    var empty = root.querySelector('[data-rev-empty]');
    var filters = [].slice.call(root.querySelectorAll('[data-rev-filter]'));
    var psel = root.querySelector('[data-rev-product]');
    var ssel = root.querySelector('[data-rev-sort]');
    var limit = items.length;
    var initial = 0;
    for (var i = 0; i < items.length; i++) { if (!items[i].hasAttribute('hidden')) initial++; }
    if (more) limit = initial;
    var current = 'all';

    function order() {
      var mode = ssel ? ssel.value : 'default';
      var list = items.slice();
      list.sort(function (a, b) {
        var sa = parseInt(a.getAttribute('data-stars') || '0', 10);
        var sb = parseInt(b.getAttribute('data-stars') || '0', 10);
        var oa = parseInt(a.getAttribute('data-order') || '0', 10);
        var ob = parseInt(b.getAttribute('data-order') || '0', 10);
        if (mode === 'high' && sa !== sb) return sb - sa;
        if (mode === 'low' && sa !== sb) return sa - sb;
        return oa - ob;
      });
      list.forEach(function (it) { grid.appendChild(it); });
      return list;
    }

    function render() {
      var seen = 0, matched = 0;
      var prod = psel ? psel.value : 'all';
      order().forEach(function (it) {
        var okStar = current === 'all' || it.getAttribute('data-stars') === current;
        var okProd = prod === 'all' || it.getAttribute('data-product') === prod;
        if (!okStar || !okProd) { it.hidden = true; return; }
        matched++;
        if (seen < limit) { it.hidden = false; seen++; }
        else { it.hidden = true; }
      });
      if (empty) empty.hidden = matched > 0;
      if (more) more.hidden = matched <= limit;
    }

    if (more) {
      more.addEventListener('click', function () {
        limit = items.length;
        render();
        more.hidden = true;
      });
    }

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        current = btn.getAttribute('data-rev-filter');
        filters.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (more) { limit = initial; more.hidden = false; }
        render();
      });
    });

    if (psel) psel.addEventListener('change', function () {
      if (more) { limit = initial; more.hidden = false; }
      render();
    });
    if (ssel) ssel.addEventListener('change', render);

    render();
  }

  /* ---------- LIÊN HỆ: kiểm tra form trước khi gửi ---------- */
  function initContactForm() {
    var wrap = document.querySelector('[data-contact-form-fields]');
    var form = wrap && wrap.closest ? wrap.closest('form') : null;
    if (!form) return;
    var fields = [].slice.call(wrap.querySelectorAll('[data-required]'));

    function msg(field) {
      var input = field.querySelector('input,textarea,select');
      if (!input) return '';
      var v = (input.value || '').trim();
      if (!v) return field.getAttribute('data-msg-empty') || 'Bạn chưa điền mục này.';
      if (input.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
        return field.getAttribute('data-msg-email') || 'Email chưa đúng định dạng.';
      }
      return '';
    }

    function check(field) {
      var err = msg(field);
      var slot = field.querySelector('[data-err]');
      field.classList.toggle('has-err', !!err);
      if (slot) { slot.textContent = err; slot.hidden = !err; }
      var input = field.querySelector('input,textarea,select');
      if (input) input.setAttribute('aria-invalid', err ? 'true' : 'false');
      return !err;
    }

    fields.forEach(function (f) {
      var input = f.querySelector('input,textarea,select');
      if (!input) return;
      input.addEventListener('blur', function () { check(f); });
      input.addEventListener('input', function () { if (f.classList.contains('has-err')) check(f); });
    });

    form.addEventListener('submit', function (e) {
      var ok = true, first = null;
      fields.forEach(function (f) {
        if (!check(f)) { ok = false; if (!first) first = f; }
      });
      if (!ok) {
        e.preventDefault();
        var input = first && first.querySelector('input,textarea,select');
        if (input) input.focus();
      }
    });
  }


  /* ---------- THANH THÔNG BÁO: luân phiên các dòng ---------- */
  function initAnnouncement() {
    var bar = document.querySelector('[data-anno]');
    if (!bar) return;
    var items = [].slice.call(bar.querySelectorAll('.anno__item'));
    if (items.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var wait = parseInt(bar.getAttribute('data-interval') || '5000', 10);
    if (!isFinite(wait) || wait < 2000) wait = 5000;
    var i = 0, timer = null;

    function show(n) {
      items.forEach(function (el, k) {
        var on = k === n;
        el.classList.toggle('is-on', on);
        if (on) { el.removeAttribute('aria-hidden'); el.removeAttribute('tabindex'); }
        else { el.setAttribute('aria-hidden', 'true'); if (el.tagName === 'A') el.setAttribute('tabindex', '-1'); }
      });
    }
    function tick() { i = (i + 1) % items.length; show(i); }
    function start() { if (!timer) timer = setInterval(tick, wait); }
    function stop() { clearInterval(timer); timer = null; }

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initDrawer(); initHero(); initAddToCart(); initQty();
    initAccordion(); initGallery(); initVariants(); QV.init(); Cart.init();
    initReviews(); initContactForm(); initAnnouncement(); initBuyNow(); initNewsletter();
  });
})();




/* Đường kẻ + đổ bóng chỉ xuất hiện khi thanh trên đã dính, không phải lúc ở đầu trang */
(function(){
  var bar = document.querySelector('.topbar');
  if(!bar) return;
  function sync(){ bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= 0.5); }
  window.addEventListener('scroll', sync, { passive:true });
  window.addEventListener('resize', sync);
  sync();
})();




/* ---------- CHUYỂN NGÔN NGỮ VI / EN ----------
   Không gắn data-i18n vào 600 thẻ. Thay vào đó: duyệt cây DOM, so chuỗi tiếng Việt
   với từ điển rồi thay tại chỗ, đồng thời nhớ bản gốc để bấm về VI là khôi phục nguyên vẹn.
   Nội dung do JS dựng sau (xem nhanh, kết quả tìm kiếm, bộ lọc) được MutationObserver bắt
   và dịch nốt. Tên sản phẩm cố tình GIỮ tiếng Việt cho tới khi Thang duyệt bản dịch. */
(function(){
  var DICT = {
/* --- 18 chuoi con sot lai, bo sung ngay 05/09 --- */
"ĐỒ ĂN VẶT VIỆT NAM": "VIETNAMESE SNACKS",
"Chợ Hẻm bắt nguồn từ hẻm, lớn lên cùng tình thương.": "Chợ Hẻm began in an alley and grew up on kindness.",
"Chợ Hẻm ra đời từ nỗi nhớ những món ăn vặt dân dã, từ hương vị quê nhà mà chúng ta luôn mang theo dù ở bất cứ nơi đâu.": "Chợ Hẻm was born from missing the humble street snacks and the flavors of home we carry with us wherever we go.",
"Chúng tôi tin rằng những món ăn giản dị cũng có thể mang lại niềm vui lớn.": "We believe the simplest food can bring the greatest joy.",
"Vì thế, Chợ Hẻm chọn lọc từng nguyên liệu, gửi gắm vào đó sự chân thành và niềm tự hào về ẩm thực Việt, để mang hương vị quê hương đến gần hơn với cộng đồng người Việt tại Mỹ.": "That is why Chợ Hẻm selects every ingredient with care, putting our sincerity and pride in Vietnamese food into each one, to bring the taste of home closer to the Vietnamese community in America.",
"Hẻm nhỏ Sài Gòn — nơi món ăn vặt bắt đầu": "A small Saigon alley — where street snacks begin",
"Những món ăn giản dị cũng có thể mang lại niềm vui lớn.": "The simplest food can bring the greatest joy.",
"Điều Chợ Hẻm giữ": "What Chợ Hẻm keeps",
"Không phẩm màu, không chất bảo quản": "No artificial colors, no preservatives",
"Đã đồng hành cùng Chợ Hẻm trên hành trình gìn giữ và lan tỏa hương vị Việt.": "For walking with Chợ Hẻm on the journey to keep and share the flavors of Vietnam.",
"Chợ Hẻm - Ở đây có vị quê nhà.": "Chợ Hẻm — the taste of home, right here.",
"Những câu chuyện nhỏ về món ăn, về con người và hành trình gìn giữ hương vị Việt.": "Small stories about food, about people, and about keeping Vietnamese flavors alive.",
"Những chia sẻ chân thật từ khách hàng là động lực để Chợ Hẻm mỗi ngày hoàn thiện hơn.": "Honest words from our customers are what push Chợ Hẻm to get better every day.",
"Chợ Hẻm tin rằng kinh doanh không chỉ là mang đến sản phẩm chất lượng mà còn là lan tỏa những giá trị tốt đẹp.": "Chợ Hẻm believes business is not only about delivering quality products, but about spreading good values.",
"Chúng tôi dành một phần doanh thu để đồng hành cùng các hoạt động thiện nguyện, hỗ trợ trẻ em có hoàn cảnh khó khăn và xây dựng cộng đồng người Việt vững mạnh tại Mỹ.": "We set aside part of our revenue to support charitable work, help children in difficult circumstances, and build a strong Vietnamese community in America.",
"Chúng tôi luôn sẵn sàng lắng nghe và hỗ trợ bạn. Đừng ngần ngại liên hệ với Chợ Hẻm nhé!": "We are always here to listen and help. Do not hesitate to reach out to Chợ Hẻm!",
"Tụi mình thường trả lời trong vòng 1 ngày làm việc.": "We usually reply within one business day.",
"Thuế và phí vận chuyển": "Taxes and shipping",
"Chúng tôi sẽ công bố tổ chức tiếp nhận, lịch chuyển khoản và báo cáo sử dụng ngay khi hoàn tất. Trước khi có thông tin xác nhận, chúng tôi không công bố con số nào.": "We'll publish the recipient organization, transfer schedule, and fund usage report once everything is confirmed. Until then, no figures will be published.", "Mỗi đóng góp của bạn và phần đóng góp của Chợ Hẻm đều được ghi nhận riêng để cùng chung tay hỗ trợ các hoạt động cộng đồng.": "Your contributions and Chợ Hẻm's are tracked separately, then brought together to support our community initiatives.", "Ví dụ căn cứ tính (cần Chợ Hẻm chốt): 5% doanh thu hàng hoá sau giảm giá, chưa gồm phí vận chuyển, thuế và đơn hoàn/huỷ.": "Example calculation basis (to be confirmed by Chợ Hẻm): 5% of merchandise revenue after discounts, excluding shipping, taxes, and refunded or canceled orders.", "Câu chuyện về một nỗi nhớ và hành trình mang hương vị quê nhà đến gần hơn với mọi người.": "A story of homesickness and the journey to bring the flavors of home a little closer.", "Đồ ăn vặt Việt Nam chính hãng, hạn sử dụng rõ ràng, giao nhanh tận nhà trên toàn Hoa Kỳ.": "Authentic Vietnamese snacks with clearly marked expiration dates, delivered fast to your door anywhere in the U.S.", "Bánh tráng, khô bò, tóp mỡ, muối chấm — gom đủ trong một đơn, giao thẳng tới nhà bạn.": "Rice paper snacks, beef jerky, pork cracklings, dipping salts — all in one order, delivered straight to your door.", "(Ô này để trống trong theme — cần Chợ Hẻm ghi đúng chính sách kế toán đã chốt.)": "(Blank in the theme — Chợ Hẻm to fill in the agreed accounting policy.)", "Những món ăn giản dị nhưng luôn đọng lại trong ký ức của mỗi người Việt.": "Simple flavors that stay in the memories of Vietnamese people everywhere.", "để mang hương vị quê hương đến gần hơn với cộng đồng người Việt tại Mỹ.": "to bring the flavors of home closer to the Vietnamese community in the U.S.", "Vài lưu ý nhỏ giúp món ăn vặt giữ được độ giòn và hương thơm lâu hơn.": "A few tips to keep your snacks crunchy and fresh.", "Bánh tráng dẻo, muối sắc đậm vị, đóng gói cẩn thận, giao hàng nhanh.": "Chewy rice paper with a bold salty kick. It was packed carefully and arrived quickly.", "từ hương vị quê nhà mà chúng ta luôn mang theo dù ở bất cứ nơi đâu.": "the flavors of home we carry with us wherever we go.", "Hộp bánh trung thu Việt Nam, đặt trước để nhận đúng dịp đoàn viên.": "Vietnamese mooncake gift boxes — pre-order now for the Mid-Autumn Festival.", "Khô gà thơm ngon, cay vừa phải. Đóng gói cẩn thận, sẽ ủng hộ thêm!": "The chicken jerky is so flavorful, with just the right amount of heat. It was packed carefully — definitely ordering again!", "Bí quyết của Chợ Hẻm trong việc chọn lọc nguyên liệu chất lượng.": "How Chợ Hẻm Selects Quality Ingredients", "Những phần quà nhỏ thay lời động viên và sẻ chia đến các em nhỏ.": "Small gifts to offer encouragement and care.", "Một lời cảm ơn gửi tới những người đã đồng hành cùng chúng tôi.": "A thank you to everyone who's been with us.", "các hoạt động thiện nguyện, hỗ trợ trẻ em có hoàn cảnh khó khăn": "charitable initiatives for children in need", "Tiếp sức đến trường, giúp các em có điều kiện học tập tốt hơn.": "Helping children stay in school with the supplies they need to learn.", "Hỗ trợ học tập và cuộc sống cho trẻ em có hoàn cảnh khó khăn.": "Supporting children in need with education and everyday essentials.", "Khô gà lá chanh ngon đúng vị, ăn là ghiền. Sẽ ủng hộ dài dài.": "The lime leaf chicken jerky tastes just like I remember. So addictive — I'll definitely be ordering again!", "Gặp gỡ, thăm hỏi và lắng nghe những câu chuyện đầy nghị lực.": "Visiting, listening, and hearing their inspiring stories of resilience.", "Mang hương vị quê hương đến với cộng đồng người Việt tại Mỹ.": "Bringing the flavors of home to the Vietnamese community across the U.S.", "Những cách sắp một hộp quà nhỏ mà ấm áp cho người thân ở xa.": "Ideas for putting together a thoughtful taste-of-home gift box for loved ones far away.", "gửi gắm vào đó sự chân thành và niềm tự hào về ẩm thực Việt,": "with sincerity and pride in Vietnamese cuisine,", "Bánh tráng dẻo, muối sắc đậm vị, ăn hoài không ngán.": "Chewy rice paper with a bold salty kick. I never get tired of it.", "Nhận ngay ưu đãi và cập nhật món ngon mới nhất từ Chợ Hẻm.": "Get special offers and discover the latest from Chợ Hẻm.", "Đồng hành mang đến những bữa ăn dinh dưỡng và yêu thương.": "Providing warm, nutritious meals with care.", "Chợ Hẻm trích 5% mỗi đơn hàng cho trẻ em mồ côi Việt Nam": "Chợ Hẻm contributes 5% from every order to support orphaned children in Vietnam", "Đồ ăn vặt chất lượng, an tâm cho sức khỏe. Rất hài lòng!": "Great-quality snacks I can feel good about eating. Very happy with my order!", "Gửi tặng nhu yếu phẩm đến những hoàn cảnh cần giúp đỡ.": "Providing essential supplies to those in need.", "Số liệu được cập nhật định kỳ và công khai minh bạch.": "Numbers are updated regularly and posted in full.", "Vị tôm rõ, cay ngon, nhà ai cũng ghiền.": "Real shrimp flavor with just the right kick. My whole family loves it!", "Chúng tôi dành một phần doanh thu để đồng hành cùng": "We set aside a portion of our revenue to support", "Kết nối và lan tỏa giá trị tốt đẹp trong cộng đồng.": "Connecting the community and sharing positive values.", "Chợ Hẻm ra đời từ nỗi nhớ những món ăn vặt dân dã,": "Chợ Hẻm was born from missing the humble street snacks", "và xây dựng cộng đồng người Việt vững mạnh tại Mỹ.": "and help build a stronger Vietnamese community in the U.S.", "Chúng tôi luôn sẵn sàng lắng nghe và hỗ trợ bạn.": "We're always here to listen and help.", "Khô mực rim đậm đà, ăn cùng cơm trắng là hết sẩy!": "The dried squid is so flavorful — perfect with a bowl of white rice!", "Mực rim mềm, thấm vị, đóng gói đẹp. 10 điểm!": "The squid is tender, flavorful, and beautifully packed. 10/10!", "là động lực để Chợ Hẻm mỗi ngày hoàn thiện hơn.": "inspires Chợ Hẻm to keep getting better every day.", "&copy; 2020–2026 Chợ Hẻm. All rights reserved.": "&copy; 2020–2026 Chợ Hẻm. All rights reserved.", "Trà lá ổi thơm nhẹ, dễ uống, pha nhanh.": "The guava leaf tea has a light aroma, goes down easy, and brews fast.", "Những câu chuyện nhỏ về món ăn, về con người": "Small Stories About Food and People", "Mẹo bảo quản đồ ăn vặt để giữ trọn hương vị": "How to store snacks so they keep their flavor", "(chờ xác nhận — đang để trống trong theme)": "(awaiting confirmation — leave blank in the theme)", "Chọn nguyên liệu ngon, làm nên món ăn ngon": "Great Ingredients Make Great Food", "Vì thế, Chợ Hẻm chọn lọc từng nguyên liệu,": "That's why Chợ Hẻm carefully selects every ingredient,", "Tổng quỹ dùng cho các hoạt động cộng đồng": "Total Community Fund", "đã đồng hành cùng Chợ Hẻm trên hành trình": "who have been with Chợ Hẻm along the way", "Chợ Hẻm tin rằng kinh doanh không chỉ là": "Chợ Hẻm believes business is about more than", "Những hoạt động chúng tôi đang thực hiện": "Our Current Initiatives", "Chúng tôi tin rằng những món ăn giản dị": "We believe even the simplest foods", "Đừng ngần ngại liên hệ với Chợ Hẻm nhé!": "Don't hesitate to reach out!", "Khoản ủng hộ được sử dụng như thế nào?": "How is your donation used?", "mang đến sản phẩm chất lượng mà còn là": "offering quality products — it's also about", "ĐỒ ĂN VẶT VIỆT NAM · GIAO TOÀN NƯỚC MỸ": "VIETNAMESE SNACKS · SHIPPING ACROSS THE U.S.", "(lấy từ email cửa hàng trong Shopify)": "(pulled from the Shopify store email)", "Cập nhật hoạt động và kết quả định kỳ": "Regular Updates on Activities and Results", "Những chia sẻ chân thật từ khách hàng": "Real Stories from Our Customers", "Gợi ý set quà tặng mang vị quê hương": "Gift set ideas with a taste of home", "và hành trình gìn giữ hương vị Việt.": "and our journey to preserve Vietnamese flavors.", "Miễn phí vận chuyển cho đơn từ $199": "Free shipping on orders $199+", "Trích 5% theo chính sách đã công bố": "5% Contribution Based on Our Published Policy", "Cùng Chợ Hẻm hỗ trợ trẻ em mồ côi.": "Join Chợ Hẻm in Supporting Orphaned Children.", "Danh mục này chưa có sản phẩm nào.": "No products in this category yet.", "Hoạt động thiện nguyện của Chợ Hẻm": "Chợ Hẻm's Community Work", "cũng có thể mang lại niềm vui lớn.": "can bring great joy.", "Tổng số tiền khách hàng đã ủng hộ": "Total Customer Contributions", "gìn giữ và lan tỏa hương vị Việt.": "preserving and sharing Vietnamese flavors.", "(để trống — chờ giờ hỗ trợ thật)": "(leave blank — awaiting confirmed support hours)", "Quỹ đã được sử dụng như thế nào?": "How has the fund been spent?", "Chưa có đánh giá nào ở mức này.": "No reviews with this rating.", "Trao tặng quà cho trẻ em mồ côi": "Gifts for Orphaned Children", "Chợ Hẻm — Ở đây có vị quê nhà.": "Chợ Hẻm — A Taste of Home.", "Cảm ơn bạn, vì đã chọn Chợ Hẻm": "Thank You for Choosing Chợ Hẻm", "KHÁCH HÀNG NÓI GÌ VỀ CHÚNG TÔI": "WHAT OUR CUSTOMERS SAY", "lan tỏa những giá trị tốt đẹp.": "creating and sharing positive impact.", "(căn cứ tính do Chợ Hẻm điền)": "(calculation basis to be provided by Chợ Hẻm)", "5 món ăn vặt gợi nhớ tuổi thơ": "5 snacks that take you back", "Từ 01.01.2026 đến 31.08.2026": "Jan 1 – Aug 31, 2026", "Từ những nhà cung cấp uy tín": "From suppliers we trust", "Bỏ qua, tới nội dung chính": "Skip to main content", "Xem chi tiết minh bạch quỹ": "View the Full Fund Report", "(lấy từ địa chỉ cửa hàng)": "(pulled from the store address)", "Sử dụng quỹ đúng mục đích": "Funds Used for Their Intended Purpose", "lớn lên cùng tình thương.": "grow up with love and care.", "100% sản phẩm chính hãng": "100% authentic products", "Giao hàng nhanh 2–4 ngày": "Ships in 2–4 days", "Hương vị Việt Nam đậm đà": "Bold Vietnamese flavor", "Đã mua hàng · 12.08.2026": "Verified Purchase · Aug 12, 2026", "(lấy từ hồ sơ cửa hàng)": "(pulled from the store profile)", "Góp một chút yêu thương": "Give a Little Love", "1. Khách hàng đóng góp": "1. Customer Contribution", "Chung tay vì cộng đồng": "Giving Back", "Câu chuyện nguyên liệu": "Our Ingredients", "Câu chuyện thương hiệu": "Our brand story", "Hỗ trợ dụng cụ học tập": "School supplies", "Vì sao Chợ Hẻm ra đời?": "Why Chợ Hẻm Exists", "Vận chuyển & giao hàng": "Shipping & delivery", "Thăm hỏi và động viên": "Visits and encouragement", "3 sản phẩm trong giỏ": "3 items in your cart", "Nhắn tin cho Chợ Hẻm qua Messenger": "Message Chợ Hẻm on Messenger", "sản phẩm trong giỏ": "items in your cart", "Cộng đồng người Việt": "Vietnamese community", "Giỏ hàng đang trống.": "Your cart is empty.", "Minh bạch quỹ ủng hộ": "Fund Transparency", "Nguyên liệu chọn lọc": "Carefully Selected Ingredients", "Ủng hộ trẻ em mồ côi": "Support Orphaned Children", "2. Chợ Hẻm đóng góp": "2. Chợ Hẻm Contribution", "Bánh ngọt & đồ uống": "Sweets & Beverages", "Cam kết của Chợ Hẻm": "Our promise", "Có thể bạn sẽ thích": "You may also like", "Dựa trên 4 đánh giá": "Based on 4 Reviews", "Khách hàng đóng góp": "Customer contributions", "Không chất bảo quản": "No preservatives", "Liên hệ với Chợ Hẻm": "Contact Chợ Hẻm", "Trao gửi yêu thương": "Passing it on", "Xem giỏ hàng đầy đủ": "View Full Cart", "Xem tất cả sản phẩm": "View all products", "Xem tất cả đánh giá": "See all reviews", "Đổi trả & hoàn tiền": "Returns & refunds", "Hành trình Chợ Hẻm": "The Chợ Hẻm Journey", "Minh bạch, rõ ràng": "Clear & Transparent", "Nấm & trái cây sấy": "Dried Mushrooms & Fruits", "Xem thêm hoạt động": "View More Activities", "DANH MỤC SẢN PHẨM": "PRODUCT CATEGORIES", "HƠN 45 MÓN ĂN VẶT": "45+ VIETNAMESE SNACKS", "HỖ TRỢ KHÁCH HÀNG": "SUPPORT", "Khách hàng nói gì": "Customer Reviews", "Lọc theo sản phẩm": "Filter by product", "Món ngon mỗi ngày": "Everyday favorites", "SẢN PHẨM BÁN CHẠY": "BEST SELLERS", "SẢN PHẨM GIẢM GIÁ": "ON SALE", "Sản phẩm bán chạy": "Best sellers", "Sản phẩm giảm giá": "On sale", "Theo dõi đơn hàng": "Track your order", "Tiếp tục mua hàng": "Continue shopping", "Tính khi checkout": "Calculated at checkout", "bắt nguồn từ hẻm,": "we grew up with — the flavors found in the little alleys of Vietnam.", "sản phẩm · Bỏ lọc": "products · Clear filters", "Chợ Hẻm đóng góp": "Chợ Hẻm Contribution", "Thời gian hỗ trợ": "Support Hours", "Tóm tắt đơn hàng": "Order summary", "ĐĂNG KÝ NHẬN TIN": "NEWSLETTER", "Đăng ký nhận tin": "Subscribe", "Đơn hàng của tôi": "My orders", "Đơn vị tiếp nhận": "Recipient Organization", "Bánh tráng trộn": "Vietnamese Rice Paper Salad", "Combo & set quà": "Combos & gift sets", "Giao hàng nhanh": "Fast delivery", "Muối chấm & sốt": "Dipping salts & sauces", "Nhật ký Chợ Hẻm": "The Chợ Hẻm Journal", "SẢN PHẨM MỚI VỀ": "NEW ARRIVALS", "Sản phẩm mới về": "New arrivals", "Tất cả bài viết": "All articles", "Tất cả sản phẩm": "All products", "Điểm thấp trước": "Lowest Rated", "Đậm đà, gần gũi": "Bold, Familiar Flavors", "Đến tận tay bạn": "Right to your door", "Bánh trung thu": "Mooncakes", "Mẹo & Bí quyết": "Tips & Tricks", "Phí vận chuyển": "Shipping", "Tổng nguồn quỹ": "Total Fund", "Điểm cao trước": "Highest Rated", "Bữa cơm ấm áp": "Warm Meals", "Email của bạn": "Your email", "Hương vị Việt": "Vietnamese flavor", "Tháng 01/2026": "January 2026", "Tháng 02/2026": "February 2026", "Tháng 03/2026": "March 2026", "Gần tới rồi!": "Almost there!", "Gửi tin nhắn": "Send message", "Khô & tóp mỡ": "Jerky & Pork Cracklings", "Quỹ sử dụng:": "Funds Used:", "Sản phẩm mới": "New", "Xem chi tiết": "See details", "vì cộng đồng": "for Our Community", "(chưa điền)": "(not filled in)", "Chọn chủ đề": "Choose a topic", "Ăn vặt Việt": "Vietnamese snacks", "Cảm ơn bạn": "Thank you", "SẮP MỞ BÁN": "COMING SOON", "Thanh toán": "Checkout", "Thành tiền": "Total", "Vận chuyển": "Shipping", "Xem tất cả": "View all", "trong từng": "in every", "Điện thoại": "Phone", "Đã sử dụng": "Spent", "Gói 5 gói": "5-Pack", "Họ và tên": "Full name", "Quê hương": "Home", "Trang chủ": "Home", "Tài khoản": "Account", "Tổng cộng": "Total", "quê hương": "home", "Đang tải…": "Loading…", "Còn hàng": "In stock", "Danh mục": "Categories", "Giỏ hàng": "Cart", "KHÁM PHÁ": "EXPLORE", "Mặc định": "Default", "Sản phẩm": "Product", "Số lượng": "Quantity", "Tin nhắn": "Message", "Tìm kiếm": "Search", "Tạm tính": "Subtotal", "Xem thêm": "See more", "Xác nhận": "Confirm", "chuẩn vị": "authentic flavor", "hương vị": "flavor", "sản phẩm": "products", "Còn lại": "Remaining", "Liên hệ": "Contact", "MUA SẮM": "SHOP", "Giá thấp → cao": "Price: low to high", "Giá cao → thấp": "Price: high to low", "Bán chạy nhất": "Best selling", "Sắp xếp": "Sort", "Số tiền": "Amount", "Địa chỉ": "Address", "Chủ đề": "Topic", "Tất cả": "All", "Số dư": "Balance", "Tháng": "Month", "Khác": "Other", "Giá": "Price", "MỚI": "NEW", "Xóa": "Remove", "Email chưa đúng, bạn kiểm tra lại giúp nhé.": "Please enter a valid email address.", "Cảm ơn bạn! Chợ Hẻm sẽ gửi tin sớm nhất.": "Thanks for subscribing!", "Đơn của bạn đã được giao hàng miễn phí.": "Your order ships free.", "Chỉ nhận số tiền chẵn (1, 2, 3…).": "Whole dollars only (1, 2, 3…).", "Email chưa đúng định dạng.": "Please enter a valid email address.", "Nhập số tiền lớn hơn 0.": "Enter an amount above 0.", "Bạn chưa điền mục này.": "This field is required.", "Miễn phí vận chuyển!": "Free Shipping!", "Tạm hết hàng": "Out of stock", "Thông tin sản phẩm": "Product details", "Mô tả sản phẩm": "Description", "Thương hiệu": "Brand", "Xuất xứ": "Origin", "Việt Nam": "Vietnam", "Mã sản phẩm": "SKU", "Quy cách": "Package Size", "Thêm vào giỏ": "Add to cart", "Mua ngay": "Buy now", "Chính hãng 100%": "100% authentic", "Hạn sử dụng dài": "Long Shelf Life", "Giao nhanh 2–4 ngày": "Fast Shipping · 2–4 Days", "Xem tất cả kết quả": "See all results", "không ủng hộ": "no donation", "Giảm": "Decrease", "Tăng": "Increase", "Thêm": "Add", "Bạn tìm món gì hôm nay?": "What are you looking for today?", "Xem sản phẩm phía trước": "Previous products", "Xem sản phẩm tiếp theo": "Next products", "Xem đánh giá phía trước": "Previous reviews", "Xem đánh giá tiếp theo": "Next reviews", "Nhập họ và tên của bạn": "Enter your full name", "Nhập nội dung tin nhắn": "Enter your message", "Thông báo từ cửa hàng": "Store announcement", "Chọn số tiền ủng hộ": "Choose a donation amount", "Hoạt động cộng đồng": "Community Initiatives", "Nhập email của bạn": "Enter your email", "Đồ ăn vặt Việt Nam": "Vietnamese snacks", "Danh mục bài viết": "Article categories", "Danh mục sản phẩm": "Product categories", "Lọc theo số sao": "Filter by rating", "Đóng xem nhanh": "Close quick view", "Đóng giỏ hàng": "Close cart", "5 trên 5 sao": "5 out of 5 stars", "Hẻm Việt Nam": "A Little Corner of Vietnam", "Mở danh mục": "Open categories", "Slide trước": "Previous slide", "Slide sau": "Next slide", "Chọn slide": "Go to slide", "Đường dẫn": "Breadcrumbs", "Lối tắt": "Shortcuts", "Ảnh trước": "Previous image", "Ảnh sau": "Next image", "Xâu": "Skewer", "Hộp": "Box", "Tiếng Việt": "Tiếng Việt", "Đã thêm vào giỏ": "Added to cart"};
  var PAT  = [["^Thêm (.+) vào giỏ$", "Add $1 to cart"], ["^Thêm một (.+)$", "Add one $1"], ["^Bớt một (.+)$", "Remove one $1"], ["^Số lượng (.+)$", "$1 quantity"], ["^Ảnh (.+) chụp sản phẩm$", "Product photo by $1"], ["^Đã bán (\\d+)$", "$1 sold"], ["^Kết quả cho “(.+)”$", "Results for “$1”"], ["^Xem tất cả kết quả cho “(.+)”$", "See all results for “$1”"], ["^Không tìm thấy món nào khớp “(.+)”\\.$", "No items match “$1”."], ["^Đang cập nhật mô tả cho (.+)\\.$", "Description for $1 is coming soon."], ["^(\\d+) sản phẩm$", "$1 products"], ["^Xem ảnh (\\d+)$", "View image $1"], ["^Thêm (.+) nữa để được giao hàng miễn phí\\.$", "Add $1 more for free shipping."], ["^Còn (.+) nữa$", "$1 to go"]].map(function(x){ return [new RegExp(x[0]), x[1]]; });
  var ATTRS = ['aria-label','placeholder','alt','title'];
  var KEY = 'chohem-lang';

  var orig = new WeakMap();      /* node -> chuỗi tiếng Việt gốc */
  var lang = 'vi', busy = false, mo = null;

  function en(vi){
    var t = vi.trim();
    if(!t) return null;
    var lead = vi.slice(0, vi.indexOf(t.charAt(0)));
    var tail = vi.slice(lead.length + t.length);
    var out = DICT[t];
    if(out === undefined){
      for(var i=0;i<PAT.length;i++){
        if(PAT[i][0].test(t)){ out = t.replace(PAT[i][0], PAT[i][1]); break; }
      }
    }
    return out === undefined ? null : lead + out + tail;
  }

  function textNodes(root){
    var out = [], w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(n){
        if(!n.nodeValue || !n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        if(!p) return NodeFilter.FILTER_REJECT;
        var tag = p.nodeName;
        if(tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEMPLATE') return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    while(w.nextNode()) out.push(w.currentNode);
    return out;
  }

  function apply(root){
    busy = true;
    var toEN = lang === 'en';
    textNodes(root).forEach(function(n){
      var src = orig.has(n) ? orig.get(n) : n.nodeValue;
      if(toEN){
        var t = en(src);
        if(t !== null && t !== n.nodeValue){ orig.set(n, src); n.nodeValue = t; }
      } else if(orig.has(n) && n.nodeValue !== src){ n.nodeValue = src; }
    });
    var els = root.querySelectorAll ? root.querySelectorAll('*') : [];
    var list = [].slice.call(els);
    if(root.nodeType === 1) list.push(root);
    list.forEach(function(el){
      ATTRS.forEach(function(a){
        if(!el.hasAttribute || !el.hasAttribute(a)) return;
        var store = el.__viAttr || (el.__viAttr = {});
        var src = (a in store) ? store[a] : el.getAttribute(a);
        if(toEN){
          var t = en(src);
          if(t !== null && t !== el.getAttribute(a)){ store[a] = src; el.setAttribute(a, t); }
        } else if(a in store && el.getAttribute(a) !== src){ el.setAttribute(a, src); }
      });
    });
    busy = false;
  }

  function setLang(next, save){
    lang = next;
    document.documentElement.lang = next;
    apply(document.body);
    [].forEach.call(document.querySelectorAll('[data-lang-cur]'), function(n){
      n.textContent = next.toUpperCase();
    });
    [].forEach.call(document.querySelectorAll('[data-lang-set]'), function(b){
      var on = b.getAttribute('data-lang-set') === next;
      b.classList.toggle('is-cur', on);
      b.setAttribute('aria-selected', String(on));
    });
    if(save){ try{ localStorage.setItem(KEY, next); }catch(e){} }
  }

  function closeMenu(){
    [].forEach.call(document.querySelectorAll('[data-lang-menu]'), function(m){ m.hidden = true; });
    [].forEach.call(document.querySelectorAll('[data-lang-btn]'), function(b){ b.setAttribute('aria-expanded','false'); });
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-lang-btn]');
    if(btn){
      e.preventDefault();
      var menu = btn.closest('[data-lang]').querySelector('[data-lang-menu]');
      var willOpen = menu.hidden;
      closeMenu();
      if(willOpen){ menu.hidden = false; btn.setAttribute('aria-expanded','true'); }
      return;
    }
    var opt = e.target.closest('[data-lang-set]');
    if(opt){ e.preventDefault(); closeMenu(); setLang(opt.getAttribute('data-lang-set'), true); return; }
    if(!e.target.closest('[data-lang]')) closeMenu();
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeMenu(); });

  function boot(){
    var saved = 'vi';
    try{ saved = localStorage.getItem(KEY) || 'vi'; }catch(e){}
    /* Nội dung dựng sau (xem nhanh, kết quả tìm kiếm) cũng phải được dịch */
    /* Gom mọi thay đổi vào một hàng đợi rồi xử một lượt ở khung hình kế.
       KHÔNG bỏ qua khi đang bận: lúc mở xem nhanh có hai đợt thay đổi liên tiếp
       (thêm <template>, rồi đổ nội dung vào hộp) — bỏ đợt sau là hộp không được dịch.
       Dịch lại một nút đã dịch thì không sinh thay đổi nào nên vòng lặp tự dừng. */
    var pending = [], queued = false;
    function flush(){
      queued = false;
      var list = pending; pending = [];
      if(lang !== 'en') return;
      list.forEach(function(n){
        if(!n || !document.body.contains(n)) return;
        apply(n.nodeType === 3 ? (n.parentNode || document.body) : n);
      });
    }
    mo = new MutationObserver(function(recs){
      if(lang !== 'en') return;
      recs.forEach(function(r){
        if(r.type === 'childList'){
          [].forEach.call(r.addedNodes, function(n){ if(n.nodeType === 1 || n.nodeType === 3) pending.push(n); });
        } else if(r.type === 'characterData'){ pending.push(r.target); }
      });
      if(!pending.length || queued) return;
      queued = true;
      requestAnimationFrame(flush);
    });
    mo.observe(document.body, { childList:true, subtree:true, characterData:true });
    if(saved === 'en') setLang('en', false); else setLang('vi', false);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();




/* ---------- HÀNG TRƯỢT NGANG ----------
   Mỗi lần bấm trượt đúng một "trang" = bề rộng khung nhìn.
   Nút tự ẩn khi không còn gì để trượt về phía đó. */
(function(){
  function init(row){
    var track = row.querySelector('.pgrid,.rgrid,.rel__grid');
    var prev  = row.querySelector('[data-crow-prev]');
    var next  = row.querySelector('[data-crow-next]');
    if(!track || !prev || !next || row.__crow) return;
    row.__crow = true;
    function sync(){
      var max = track.scrollWidth - track.clientWidth;
      if(max < 4){ prev.hidden = next.hidden = true; return; }
      prev.hidden = next.hidden = false;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }
    function page(dir){
      /* MTBN-C: phải lấy thẻ đầu tiên CÒN HIỆN (hàng gợi ý ẩn món đã có trong giỏ; thẻ ẩn rộng 0 → bước trượt NaN → đứng im) */
      var card = null, kids = track.children;
      for(var i = 0; i < kids.length; i++){ if(kids[i].getBoundingClientRect().width > 0){ card = kids[i]; break; } }
      var cw = card ? card.getBoundingClientRect().width : 0;
      var step = cw > 0 ? Math.round(track.clientWidth / cw) * cw : 0;
      if(!isFinite(step) || step <= 0) step = track.clientWidth;
      /* trừ đi gap cuối cho khỏi hụt nửa thẻ */
      track.scrollBy({ left: dir * Math.max(step, track.clientWidth * .8), behavior: 'smooth' });
    }
    prev.addEventListener('click', function(){ page(-1); });
    next.addEventListener('click', function(){ page(1); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    /* Hàng nằm trong trang/ngăn kéo đang ẩn thì lúc khởi tạo clientWidth = 0,
       sync() tưởng không có gì để trượt nên giấu luôn hai mũi tên — và không sự
       kiện nào đánh thức nó khi hàng hiện ra. Theo dõi kích thước để tính lại. */
    if (window.ResizeObserver) new ResizeObserver(sync).observe(track);
    /* thẻ ẩn/hiện khi lọc danh mục cũng làm đổi bề rộng cuộn */
    new MutationObserver(sync).observe(track, { attributes:true, childList:true, subtree:true, attributeFilter:['hidden'] });
    sync();
  }
  function boot(){
    [].forEach.call(document.querySelectorAll('[data-crow]'), init);
    /* Hàng gợi ý trong quick view chỉ tồn tại sau khi mở hộp -> gắn nút khi nó xuất hiện */
    new MutationObserver(function(recs){
      recs.forEach(function(r){
        [].forEach.call(r.addedNodes, function(n){
          if(n.nodeType !== 1) return;
          if(n.matches && n.matches('[data-crow]')) init(n);
          if(n.querySelectorAll) [].forEach.call(n.querySelectorAll('[data-crow]'), init);
        });
      });
    }).observe(document.body, { childList:true, subtree:true });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();




/* ---------- TÌM KIẾM ----------
   Bỏ dấu tiếng Việt hai đầu để gõ "banh trang" cũng ra "Bánh tráng".
   Gõ -> danh sách gợi ý; Enter hoặc "Xem tất cả kết quả" -> lưới kết quả. */
(function(){
  var IDX = (function(){ try { return JSON.parse(document.getElementById('chohem-IDX').textContent); } catch(e){ return []; } })();
  function fold(t){
    return String(t).toLowerCase().normalize('NFD')
      .replace(/[̀-ͯ]/g,'').replace(/đ/g,'d').replace(/\s+/g,' ').trim();
  }
  IDX.forEach(function(it){ it.f = fold(it.n) + ' ' + fold(it.s); it.fc = fold(it.cn||''); });   /* TIM: f = tên+SKU, fc = tên danh mục (chỉ dùng dự phòng) */

  var form  = document.querySelector('.search__form');
  var input = document.getElementById('s');
  if(!form || !input) return;

  var box = document.createElement('div');
  box.className = 'sresults'; box.hidden = true;
  box.setAttribute('role','listbox');
  form.appendChild(box);

  var cur = -1, hits = [];

  function money(c){ return c ? '$' + (c/100).toFixed(2) : 'Liên hệ'; }
  function mark(name, q){
    var i = fold(name).indexOf(q);
    if(i < 0) return name;
    return name.slice(0,i) + '<mark>' + name.slice(i, i+q.length) + '</mark>' + name.slice(i+q.length);
  }
  var total = 0, groups = [];   /* TIM: total = số món khớp; groups = nhóm theo danh mục, CHỈ có khi không món nào khớp tên/SKU */
  function search(q){
    q = fold(q); groups = [];
    if(q.length < 1){ total = 0; return []; }
    var starts = [], contains = [];
    IDX.forEach(function(it){
      var i = it.f.indexOf(q);
      if(i >= 0) (i === 0 ? starts : contains).push(it);
    });
    var name = starts.concat(contains);   /* hiện HẾT, không cắt 8 — hộp tự cuộn */
    if(!name.length){                     /* dự phòng: "trung thu" không có trong tên bánh nào → dò tên danh mục */
      var byCat = {}, order = [];
      IDX.forEach(function(it){
        if(it.fc && it.fc.indexOf(q) >= 0){ if(!byCat[it.cn]){ byCat[it.cn] = []; order.push(it.cn); } byCat[it.cn].push(it); }
      });
      order.forEach(function(cn){ groups.push({cn: cn, items: byCat[cn]}); });
    }
    total = name.length; groups.forEach(function(g){ total += g.items.length; });
    return name;
  }
  function row(it, q){
    return '<button class="sresult" type="button" role="option" data-h="' + it.h + '">' +
      '<span class="sresult__thumb"><img data-img="' + it.h + '" alt=""></span>' +
      '<span class="sresult__txt"><span class="sresult__name">' + mark(it.n, fold(q)) + '</span>' +
      '<span class="sresult__meta">' + (it.v ? it.v + ' · ' : '') + it.s + '</span></span>' +
      '<span class="sresult__price">' + money(it.p) + '</span></button>';
  }
  function fitMobile(){   /* TIM: ≤900 hộp trải hết bề ngang thanh trên (form vẫn position:relative nên icon kính lúp không đổi chỗ) */
    var bar = form.closest('.mobilebar');
    if(bar && matchMedia('(max-width:900px)').matches){
      var fr = form.getBoundingClientRect(), br = bar.getBoundingClientRect();
      box.style.left = (br.left + 12 - fr.left) + 'px'; box.style.right = (fr.right - (br.right - 12)) + 'px';
    } else { box.style.left = ''; box.style.right = ''; }
  }
  function render(q){
    var name = search(q); cur = -1;
    hits = name.slice(); groups.forEach(function(g){ hits = hits.concat(g.items); });
    if(!q.trim()){ box.hidden = true; box.innerHTML = ''; return; }
    if(!hits.length){
      box.innerHTML = '<p class="sresults__none">Không tìm thấy món nào khớp “' +
        q.replace(/[<>&]/g,'') + '”.</p>';
      fitMobile(); box.hidden = false; return;
    }
    var html = name.map(function(it){ return row(it, q); }).join('');
    groups.forEach(function(g){
      html += '<p class="sresults__sep">Thuộc danh mục «' + g.cn + '»</p>' + g.items.map(function(it){ return row(it, q); }).join('');
    });
    box.innerHTML = html + '<button class="sresults__all" type="button" data-all>Xem tất cả ' + total + ' kết quả cho “' +
      q.replace(/[<>&]/g,'') + '”</button>';
    if(window.CHFixImg) window.CHFixImg(box);
    fitMobile(); box.hidden = false;
  }
  function close(){ box.hidden = true; cur = -1; }
  function move(d){
    var items = box.querySelectorAll('.sresult');
    if(!items.length) return;
    if(cur >= 0) items[cur].classList.remove('is-cur');
    cur = (cur + d + items.length + 1) % (items.length + 1);
    if(cur === items.length) cur = d > 0 ? 0 : items.length - 1;
    items[cur].classList.add('is-cur');
    items[cur].scrollIntoView({ block:'nearest' });
  }
  function openProduct(h){
    close(); input.blur();
    var trigger = document.querySelector('[data-quick-view="' + h + '"]');
    if(trigger){ trigger.click(); return; }
    /* sản phẩm không nằm trong phần đang hiển thị -> mở lưới rồi bấm */
    showAll(input.value);
    setTimeout(function(){
      var t = document.querySelector('[data-quick-view="' + h + '"]');
      if(t) t.click();
    }, 60);
  }
  /* mở lưới kết quả — dùng lại đúng bộ máy lọc danh mục */
  function showAll(q){
    close();
    var CH5 = (window.CH_ROUTES || {});
    if (String(q).trim()) window.location.href = (CH5.search || '/search') + '?q=' + encodeURIComponent(String(q).trim());
  }

  input.addEventListener('input', function(){ render(input.value); });
  input.addEventListener('focus', function(){ if(input.value.trim()) render(input.value); });
  input.addEventListener('keydown', function(e){
    if(e.key === 'ArrowDown'){ e.preventDefault(); move(1); }
    else if(e.key === 'ArrowUp'){ e.preventDefault(); move(-1); }
    else if(e.key === 'Escape'){ close(); }
    else if(e.key === 'Enter'){
      e.preventDefault();
      var items = box.querySelectorAll('.sresult');
      if(cur >= 0 && items[cur]) openProduct(items[cur].getAttribute('data-h'));
      else showAll(input.value);
    }
  });
  form.addEventListener('submit', function(e){ if(!String(input.value).trim()) e.preventDefault(); close(); });
  box.addEventListener('click', function(e){
    var b = e.target.closest('.sresult');
    if(b){ openProduct(b.getAttribute('data-h')); return; }
    if(e.target.closest('[data-all]')) showAll(input.value);
  });
  document.addEventListener('click', function(e){
    if(!form.contains(e.target)) close();
  });
})();




/* ---------- SẮP XẾP LƯỚI DANH MỤC (bản theme) ----------
   Web HTML lọc danh mục bằng hash #/c/…; trên Shopify mỗi danh mục là một trang thật,
   nên khối này chỉ giữ phần sắp xếp tại chỗ — cùng ba phép so sánh, món "Liên hệ" luôn xuống cuối. */
(function(){
  var sec = document.querySelector('[data-catsec]'); if(!sec) return;
  var grid = sec.querySelector('[data-catsec-grid]'); if(!grid) return;
  var cards = [].slice.call(grid.querySelectorAll('.pcard'));
  cards.forEach(function(c, i){ c.__ord = i; });
  var sortSel = sec.querySelector('[data-catsec-sort]');
  function priceOf(c){ var b = c.querySelector('[data-demo-item]'); if(!b) return 0;
    try { return JSON.parse(b.getAttribute('data-demo-item')).p || 0; } catch(e){ return 0; } }
  function soldOf(c){ return parseInt(c.getAttribute('data-sold') || '0', 10); }
  function applySort(){
    var key = sortSel ? sortSel.value : '', cmp;
    if(key === 'price-ascending') cmp = function(a,b){ var x=priceOf(a)||Infinity, y=priceOf(b)||Infinity; return x-y || a.__ord-b.__ord; };
    else if(key === 'price-descending') cmp = function(a,b){ var x=priceOf(a), y=priceOf(b);
      if(!x && !y) return a.__ord-b.__ord; if(!x) return 1; if(!y) return -1; return y-x || a.__ord-b.__ord; };
    else if(key === 'best-selling') cmp = function(a,b){ return soldOf(b)-soldOf(a) || a.__ord-b.__ord; };
    else cmp = function(a,b){ return a.__ord-b.__ord; };
    cards.slice().sort(cmp).forEach(function(c){ grid.appendChild(c); });
    /* ghi lên URL để tải lại vẫn giữ, và để trang sau (phân trang) đi đúng thứ tự */
    try { var u = new URL(window.location.href); if(key && key !== 'manual') u.searchParams.set('sort_by', key); else u.searchParams.delete('sort_by');
      history.replaceState(null, '', u.toString()); } catch(e){}
  }
  if(sortSel) sortSel.addEventListener('change', applySort);
  var sale = document.querySelector('[data-salesec]'); if(sale && !sale.querySelector('.pcard')) sale.hidden = true;
})();



/* ---------- LỌC BÀI VIẾT THEO DANH MỤC ----------
   Trước đây 5 dòng danh mục đều trỏ href="#/p2" (trang bài viết) hoặc "#", nên bấm
   vào là nhảy sang bài viết hoặc không có gì xảy ra — trông như bấm không được.
   Lọc theo data-jcat trên thẻ chứ không theo chữ hiển thị, để bản EN vẫn lọc đúng. */
(function(){
  function apply(key){
    var grid = document.querySelector('.jgrid'); if(!grid) return;
    var seen = 0;
    [].forEach.call(grid.querySelectorAll('.jcard'), function(c){
      var on = !key || c.getAttribute('data-jcat') === key;
      c.hidden = !on; if(on) seen++;
    });
    var empty = document.querySelector('[data-jempty]'); if(empty) empty.hidden = seen > 0;
  }
  document.addEventListener('click', function(e){
    var a = e.target.closest('[data-jfilter]'); if(!a) return;
    e.preventDefault();
    [].forEach.call(document.querySelectorAll('[data-jfilter]'), function(x){
      x.classList.toggle('is-active', x === a);
    });
    apply(a.getAttribute('data-jfilter'));
  });
})();



/* =================================================================
   DEMO MOBILE — chuyển bố cục sang kiểu Weee, giữ nguyên hệ Chợ Hẻm.
   Không nhân bản phần tử: ô tìm được DI CHUYỂN, dải chip dựng lại từ
   chính quicknav + catnav ở cột trái nên icon là bộ Tabler web đang dùng.
   ================================================================= */
(function(){
  var MQ = window.matchMedia('(max-width:900px)');
  var bar   = document.querySelector('.mobilebar');
  var tim   = document.querySelector('.topbar .search');
  var timCha= tim && tim.parentElement;
  var acts  = document.querySelector('.topbar__actions');
  var rail, filt, phuMenu;

  function chuHoa(t){ t=t.trim(); return t.charAt(0).toUpperCase()+t.slice(1); }

  /* ---- 5-C: gắn số sản phẩm vào tiêu đề danh mục ---- */
  function soDanhMuc(){
    var t=document.querySelector('.catsec .section__title'),
        m=document.querySelector('.catsec .catsec__meta');
    if(!t) return;
    if(!MQ.matches){ t.removeAttribute('data-n'); return; }
    var n = m ? (m.textContent.match(/\d+/)||[''])[0] : '';
    if(n) t.setAttribute('data-n',n); else t.removeAttribute('data-n');
  }

  /* ---- 4-A: gập các nhóm liên kết chân trang ---- */
  function gapChanTrang(){
    document.querySelectorAll('.footer__cols>div').forEach(function(d){
      if(d.classList.contains('fgrp')) return;
      var t=d.querySelector(':scope>.footer__title'), nv=d.querySelector(':scope>nav');
      if(!t||!nv) return;
      d.classList.add('fgrp');
      t.setAttribute('role','button'); t.tabIndex=0; t.setAttribute('aria-expanded','false');
      function bat(){
        if(!MQ.matches) return;
        var mo=d.classList.toggle('is-open');
        t.setAttribute('aria-expanded', mo?'true':'false');
      }
      t.addEventListener('click',bat);
      t.addEventListener('keydown',function(e){
        if(e.key==='Enter'||e.key===' '){ e.preventDefault(); bat(); }
      });
    });
  }


  function dungRail(){
    if(rail) return rail;
    rail=document.createElement('nav');
    rail.className='mrail'; rail.setAttribute('aria-label','Danh mục');
    var inn=document.createElement('div'); inn.className='mrail__in';
    var nguon=[];
    document.querySelectorAll('.quicknav__item').forEach(function(a){nguon.push({a:a,uu:true});});
    document.querySelectorAll('.catnav__link').forEach(function(a){nguon.push({a:a,uu:false});});
    nguon.forEach(function(o){
      var a=document.createElement('a');
      a.className='mrail__i'+(o.uu?' mrail__i--uu':'');
      a.href=o.a.getAttribute('href')||'#';
      var ic=o.a.querySelector('svg'); if(ic) a.appendChild(ic.cloneNode(true));
      var nh=o.a.querySelector('.catnav__label')||o.a.querySelector('span:last-child');
      var t=document.createElement('span');
      t.textContent=chuHoa((nh?nh.textContent:o.a.textContent)
        .replace(/^\s*Sản phẩm\s+/,'').replace(/^\s*Tất cả sản phẩm\s*$/,'Tất cả'));
      a.appendChild(t);
      if(o.a.classList.contains('is-active')) a.classList.add('is-on');
      inn.appendChild(a);
    });
    rail.appendChild(inn); return rail;
  }

  function dungFilter(){
    if(filt) return filt;
    filt=document.createElement('div'); filt.className='mfilter';
    var inn=document.createElement('div'); inn.className='mfilter__in';
    document.querySelectorAll('.catnav__link').forEach(function(a,i){
      var b=document.createElement('a');
      b.className='mfilter__p'+(i===0?' is-on':'');
      b.href=a.getAttribute('href')||'#';
      var nh=a.querySelector('.catnav__label');
      b.textContent=(nh?nh.textContent:a.textContent).trim();
      inn.appendChild(b);
    });
    filt.appendChild(inn); return filt;
  }

  function bat(){
    if(!bar) return;
    document.body.setAttribute('data-cot', document.body.getAttribute('data-cot')||'3');
    var gio=bar.querySelector('.action');
    if(tim && tim.parentElement!==bar){ gio?bar.insertBefore(tim,gio):bar.appendChild(tim); }
    /* Tài khoản + ngôn ngữ chuyển xuống menu ☰ để thanh trên còn đúng một hàng */
    if(acts && !phuMenu){
      var sb=document.querySelector('.sidebar');
      if(sb){ phuMenu=document.createElement('div'); phuMenu.className='mextra';
        phuMenu.style.cssText='padding:14px 24px 4px;border-top:1px solid var(--line-soft);margin-top:12px';
        phuMenu.appendChild(acts); sb.appendChild(phuMenu); }
    }
    var r=dungRail();
    if(r.parentElement!==bar.parentElement) bar.parentElement.insertBefore(r, bar.nextSibling);
    gapChanTrang();
    soDanhMuc();
  }
  function tat(){
    if(tim && timCha && tim.parentElement!==timCha) timCha.appendChild(tim);
    if(acts && phuMenu){ var tb=document.querySelector('.topbar');
      if(tb) tb.appendChild(acts);
      if(phuMenu.parentElement) phuMenu.parentElement.removeChild(phuMenu);
      phuMenu=null; }
    if(rail&&rail.parentElement) rail.parentElement.removeChild(rail);
    document.querySelectorAll('.catsec .section__title[data-n]')
      .forEach(function(t){t.removeAttribute('data-n');});
  }
  function chay(){ MQ.matches?bat():tat(); }
  document.addEventListener('DOMContentLoaded',chay);
  if(document.readyState!=='loading') chay();
  MQ.addEventListener?MQ.addEventListener('change',chay):MQ.addListener(chay);
  /* Đổi danh mục thì tiêu đề đổi theo — bám vào thay đổi DOM để gắn lại số. */
  new MutationObserver(function(){ if(MQ.matches) soDanhMuc(); })
    .observe(document.body,{childList:true,subtree:true,characterData:true});
  window.addEventListener('hashchange',function(){ if(MQ.matches) setTimeout(soDanhMuc,0); });

  document.addEventListener('click',function(e){
    if(e.target.closest('[data-anno-close]')){
      var a=e.target.closest('.anno'); if(a) a.classList.add('is-off'); return; }
    var p=e.target.closest('.mfilter__p');
    if(p){ p.parentElement.querySelectorAll('.mfilter__p').forEach(function(x){x.classList.remove('is-on');});
      p.classList.add('is-on'); return; }
    var m=e.target.closest('.mrail__i');
    if(m){ m.parentElement.querySelectorAll('.mrail__i').forEach(function(x){x.classList.remove('is-on');});
      m.classList.add('is-on'); }
  });
  /* để chụp ảnh và thử 2 cột: window.__cot(2) hoặc __cot(3) */
  window.__cot=function(n){ document.body.setAttribute('data-cot',String(n)); };
})();




/* ==================================================================
   ĐỢT CHỐT 9 VIỆC — phần JS
   ================================================================== */
(function(){
  var MQ = window.matchMedia('(max-width:900px)');

  /* ---------- D-4: ba nhóm chữ trong ngăn ☰ ---------- */
  var NHOM = [
    ['MUA SẮM', [['Sản phẩm bán chạy','#/f/best'],['Sản phẩm mới về','#/f/new'],
                 ['Sản phẩm giảm giá','#/f/sale'],['Tất cả sản phẩm','#/c/all']]],
    ['KHÁM PHÁ',[['Câu chuyện thương hiệu','#/p1'],['Nhật ký Chợ Hẻm','#/p2'],
                 ['Khách hàng nói gì','#/p3'],['Chung tay vì cộng đồng','#/p4']]],
    ['HỖ TRỢ KHÁCH HÀNG',[['Liên hệ','#/p5'],['Theo dõi đơn hàng','#'],
                 ['Vận chuyển & giao hàng','#'],['Đổi trả & hoàn tiền','#']]]
  ];
  function dungNhom(){
    var sb = document.querySelector('.sidebar');
    if(!sb || sb.querySelector('.nmuc')) return;
    var moc = sb.querySelector('.mextra');
    NHOM.forEach(function(g){
      var d = document.createElement('div'); d.className = 'nmuc';
      var h = document.createElement('p'); h.className = 'nmuc__h';
      h.textContent = g[0]; d.appendChild(h);
      g[1].forEach(function(x){
        var a = document.createElement('a'); a.href = (window.CHHref ? window.CHHref(x[1]) : x[1]); a.textContent = x[0];
        d.appendChild(a);
      });
      sb.appendChild(d);
    });
  }

  /* ---------- Nút đóng ngăn ---------- */
  var XSVG = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"'
    + ' stroke-width="1.7" stroke-linecap="round" aria-hidden="true" focusable="false">'
    + '<path d="M6 6l12 12M18 6L6 18"/></svg>';
  function themDong(){
    var sb = document.querySelector('.sidebar');
    if(!sb || sb.querySelector('.sbclose')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'sbclose';
    b.setAttribute('aria-label','Đóng menu');
    b.innerHTML = XSVG;
    b.addEventListener('click', function(){
      var t = document.querySelector('.mobilebar__burger');
      if(t) t.click();
      sb.classList.remove('is-open');
    });
    sb.appendChild(b);
  }

  /* ---------- Y-3: "VI" → "Tiếng Việt", và giữ được sau khi đổi ngôn ngữ ----------
     JS sẵn có của web ghi lại mã hai chữ cái mỗi lần chuyển, nên phải
     bám vào thay đổi của chính ô đó rồi dịch lại. */
  var TEN = {VI:'Tiếng Việt', EN:'English'};
  function tenDai(){
    var l = document.querySelector('.sidebar .mextra [data-lang-cur]');
    if(!l) return;
    var t = (l.textContent || '').trim().toUpperCase();
    if(TEN[t]) l.textContent = TEN[t];
  }
  function theoDoiNgonNgu(){
    var l = document.querySelector('.sidebar .mextra [data-lang-cur]');
    if(!l || l.dataset.theo) return;
    l.dataset.theo = '1';
    new MutationObserver(function(){ if(MQ.matches) tenDai(); })
      .observe(l, {childList:true, characterData:true, subtree:true});
    tenDai();
  }

  /* ---------- Ba lỗi dải chip ----------
     1. chip sáng không khớp trang khi vào bằng đường khác
     2. chip đang chọn nằm ngoài màn hình, dải không tự kéo vào
     3. trang chủ vẫn sáng chip "Bán chạy"
     Chỉ trang danh mục / lọc mới có chip tương ứng; trang chủ, giỏ hàng,
     các trang nội dung -> không chip nào sáng. */
  function duongDanHienTai(){
    var t = document.querySelector('.catsec .section__title');
    if(!t || !t.offsetParent) return '';
    var a = document.querySelector('.catnav__link.is-active,.quicknav__item.is-active');
    return a ? (a.getAttribute('href') || '') : '';
  }
  function dongBoChip(){
    if(!MQ.matches) return;
    var cs = [].slice.call(document.querySelectorAll('.mrail__i'));
    if(!cs.length) return;
    var h = duongDanHienTai(), tim = null;
    cs.forEach(function(c){
      var on = h && c.getAttribute('href') === h;
      c.classList.toggle('is-on', !!on);
      c.setAttribute('aria-current', on ? 'page' : 'false');
      if(on) tim = c;
    });
    if(tim){
      var inn = tim.parentElement;
      inn.scrollTo({left: Math.max(0, tim.offsetLeft - (inn.clientWidth - tim.offsetWidth)/2),
                    behavior:'smooth'});
    }
  }

  function chay(){
    if(!MQ.matches) return;
    setTimeout(function(){
      dungNhom();
      themDong();
      theoDoiNgonNgu();
      dongBoChip();
    }, 140);
  }
  document.addEventListener('DOMContentLoaded', chay);
  if(document.readyState !== 'loading') chay();
  MQ.addEventListener ? MQ.addEventListener('change', chay) : MQ.addListener(chay);

  document.addEventListener('click', function(e){
    if(e.target.closest('.mrail__i')) setTimeout(dongBoChip, 60);
  }, true);
  window.addEventListener('hashchange', function(){ setTimeout(dongBoChip, 60); });
  new MutationObserver(function(){ if(MQ.matches) setTimeout(dongBoChip, 0); })
    .observe(document.body, {childList:true, subtree:true});
})();




/* ---- Bấm link điều hướng trong ngăn ☰ thì đóng ngăn lại ----
   Ngăn chỉ đóng được bằng nút ✕, lớp phủ và phím Esc. 12 link trong ba nhóm
   đổi trang nhưng để ngăn che mất nội dung vừa mở. Chỉ đóng với link thật
   sự điều hướng (href bắt đầu bằng "#/"), không đóng với href="#". */
(function () {
  function gan() {
    var sb = document.querySelector('.sidebar');
    if (!sb || sb.getAttribute('data-dong-ngan')) return false;
    sb.setAttribute('data-dong-ngan', '1');
    sb.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('a[href],.lang__opt,.lang__btn') : null;
      if (!t || !sb.contains(t)) return;
      /* Nút mở menu ngôn ngữ thì KHÔNG đóng, nếu không menu con vừa mở đã biến mất. */
      if (t.classList.contains('lang__btn')) return;
      setTimeout(function () {
        if (document.body.classList.contains('drawer-open')) {
          var t = document.querySelector('.mobilebar__burger');
          if (t) t.click();
        }
      }, 0);
    });
    return true;
  }
  if (!gan()) {
    var id = setInterval(function () { if (gan()) clearInterval(id); }, 200);
    setTimeout(function () { clearInterval(id); }, 8000);
  }
})();



/* ===== N-3 · O so luong: go tay phai an =====
   Ban goc chi co handler cho nut +/-; go vao <input> khong lam gi ca:
   o hien "999" ma gio hang van tinh 1. Doan nay ket noi lai: doc so
   nguoi dung go, kep ve so nguyen 0..99, roi bam ho nut +/- dung so lan.
   Khong dung vao code goc, khong can biet bien ben trong. */
(function(){
  var truoc = new WeakMap();
  function cua(e){ return e.target && e.target.closest ? e.target.closest('[data-demo-qty-input]') : null; }
  document.addEventListener('focusin', function(e){
    var i = cua(e); if (i) truoc.set(i, parseInt(i.value, 10) || 0);
  }, true);
  function ap(inp){
    var cu = truoc.has(inp) ? truoc.get(inp) : (parseInt(inp.value,10) || 0);
    var v  = parseFloat(inp.value);
    v = isFinite(v) ? Math.round(v) : cu;
    if (v < 0)  v = 0;
    if (v > 99) v = 99;
    var box = inp.closest('.qty');
    if (!box) { inp.value = v; return; }
    var up   = box.querySelector('[data-demo-qty="up"]');
    var down = box.querySelector('[data-demo-qty="down"]');
    if (!up || !down) { inp.value = v; return; }
    inp.blur();                       /* de render() duoc phep ghi lai o */
    var d = v - cu, btn = d > 0 ? up : down, n = Math.abs(d);
    if (n > 200) n = 200;             /* chan vong lap dai */
    for (var i = 0; i < n; i++) btn.click();
    truoc.set(inp, v);
  }
  document.addEventListener('change', function(e){ var i = cua(e); if (i) ap(i); });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter') return;
    var i = cua(e); if (i) { e.preventDefault(); ap(i); }
  });
})();




(function(){
  var SAN=162, TL=1.216;
  function dong(){
    var khe = innerWidth<=620 ? 8 : 14;
    var ds = document.querySelectorAll('.catsec .pgrid, .crow>.pgrid, .crow>.rgrid');
    var C=0; for(var i=0;i<ds.length;i++) if(ds[i].clientWidth>C) C=ds[i].clientWidth;
    if(C<50) return;
    var san = Math.min(SAN, (C-khe)/2);
    var n = Math.max(1, Math.floor((C+khe)/(san+khe)));
    var the = (C-(n-1)*khe)/n;
    document.documentElement.classList.add('luat-js');
    document.documentElement.style.setProperty('--rv',(the*TL).toFixed(2)+'px');
  }
  var t; function hen(){clearTimeout(t);t=setTimeout(dong,60);}
  if(document.readyState!=='loading') dong(); else document.addEventListener('DOMContentLoaded',dong);
  addEventListener('resize',hen); window.__luatThe=dong;
})();


/* ===== FOCUS (chốt v111): nhớ kiểu nhập — chạm tay thì không vẽ vòng focus ===== */
(function(){
  var h=document.documentElement;
  function tay(){h.classList.add('m-pointer');h.classList.remove('m-key');}
  function phim(e){if(e.key==='Tab'||e.key==='Enter'||e.key===' '||(e.key&&e.key.indexOf('Arrow')===0)){h.classList.add('m-key');h.classList.remove('m-pointer');}}
  window.addEventListener('pointerdown',tay,true);
  window.addEventListener('touchstart',tay,true);
  window.addEventListener('mousedown',tay,true);
  window.addEventListener('keydown',phim,true);
})();
